import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Accordion, Card, Tab, Nav, ListGroup, Col, Row } from 'react-bootstrap';

import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { format as stringFormat } from 'react-string-format';

import { URL_IMG } from '../../configs/urlConfigs';
import { MSG_ACCEP_GOING_CANCELLED, MSG_QUOTE_MAIL_SEND, MSG_SHIFT_UPDATE, MSG_SHIFT_DELETE, MSG_QUOTE_MAIL_SEND_ERROR, MSG_QUOTE_REJECTED, MSG_QUOTE_ACCEPTED, MSG_SERVER_DATA_FETCH_ERROR, MSG_EVENT_NOT_EXISTS, MSG_SHIFT_CANCELLED, MSG_SHIFT_CANCEL_ERROR, MSG_SHIFT_UPDATE_ERROR, MSG_SHIFT_UPDATE_PAST_TIME_ERROR, MSG_SHIFT_DELETE_ERROR, MSG_QUOTE_REQUESTED, MSG_QUOTE_DOWNLOAD_ERROR, MSG_INVOICE_DOWNLOAD_ERROR, MSG_INVOICE_MAIL_SEND, MSG_INVOICE_MAIL_SEND_ERROR, MSG_DISCOUNT_VALID_ERROR, MSG_REQUIRED, MSG_DISCOUNT_EDIT_SUCCESS, MSG_DISCOUNT_EDIT_ERROR, MSG_SHIFT_NO_DEPT_ERROR, MSG_SHIFT_NOT_FOUND, MSG_CREW_NOT_ACCEPTED, MSG_RESEND_QUOTE_FOR_CLIENT_APPROVAL, MSG_CSV_DOWNLOAD_ERROR, MSG_SHIFT_TIME_CHANGE_ACCEPT_FAILED, MSG_SHIFT_TIME_CHANGE_REJECT_FAILED, MSG_INVOICE_GENERATION_SUCCESS, MSG_INVOICE_GENERATION_ERROR, MSG_PDF_DOWNLOAD_ERROR, MSG_INVOICE_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED, MSG_INVOICE_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED, MSG_SHIFT_TIME_CHANGE_ACCEPT_SUCCESS } from '../../configs/msgConfigs';

import Toast from '../commons/helpers/toast';
import ModalWindow from '../commons/helpers/modalWindow';
import LogComponent from '../commons/logComponent';
import InvoiceComponent from '../commons/invoiceComponent';

import { SEARCH_TEXT_COUNT, TAB1, TAB2, TAB3, TAB4, TAB5, TAB6, TAB7, EVENT_STATUS, SHIFT_STATUS, QUOTE_STATUS, QUOTE_SENT, ROUTE_AFFILIATE_SCHEDULE_SHIFT, ROUTE_AFFILIATE_EVENTS, ROUTE_CLIENT_EVENTS, CREW_MAX_RATING, EVENT_STATUS_COMPLETED, SHIFT_STATUS_CANCELLED, SHIFT_STATUS_ON_GOING, SHIFT_STATUS_COMPLETED, LOGIN_SUPER_ADMIN_GROUP, DISCOUNT_TYPE_AMOUNT, DISCOUNT_TYPE_PERCENTAGE, EVENT_STATUS_INVOICED, CLIENT_EMAILS_MUTED, AFFILIATE_ALL_CLIENTS_EMAILS_MUTED, SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE, SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE, SCHEDULE_CREW_STATUS, SHIFT_CANCEL_ERROR_CODE } from '../../configs/staticConfigs';
import { getUserTimeZone, userGroupUrlCheck } from '../../utils/userGroupUrlCheck';

import { LBL_REMOVE_AFF_VEHICLE, LBL_REMOVE_CREW_VEHICLE, LBL_SELECT_VEHICLE, LBL_OR, LBL_AFF_VEH_DETAILS, LBL_NOT_SELECTED, LBL_INVOICE, LBL_INFO, LBL_NO_MESSAGES, LBL_MESSAGE_TO, LBL_AFFILIATE, LBL_EDIT_QUOTE, LBL_SEND, LBL_MESSAGES, LBL_QUOTE, LBL_EVENT, LBL_SHIFTS, LBL_VAT, LBL_SCHEDULE_SHIFT, LBL_LOG, LBL_EVENT_PREFIX, LBL_CREW, LBL_HOURS_SHORT, LBL_QUOTE_SUMMARY, LBL_EVENT_SUMMARY, LBL_CLIENT, LBL_CLIENT_DETAILS, LBL_AFFILIATE_DETAILS, LBL_PREVIEW_QUOTE, LBL_SEND_QUOTE, LBL_ACCEPT_QUOTE, LBL_REQUEST_QUOTE, LBL_ADD_SHIFT, LBL_TO, LBL_CONFIRM_DELETE_SHIFT, LBL_CONFIRM_DELETE, LBL_CONFIRM_CANCEL_SHIFT, LBL_OFFICE_CONTACT, LBL_QUOTE_STATUS, LBL_EDIT, LBL_REJECT_QUOTE, LBL_CANCEL, LBL_DELETE, LBL_SUB_TOTAL, LBL_GRAND_TOTAL, LBL_NOTES, LBL_MEMBERS_REQUIRED, LBL_ACCEPTED, LBL_REQUESTED, LBL_SHIFT_NAME, LBL_SHIFT_TIME, LBL_SHIFT_STATUS, LBL_DUPLICATE, LBL_SLNUM, LBL_COMPLETE, LBL_ADD_NEW_CLIENT_CONTACT, LBL_DISCOUNT, LBL_EDIT_DISCOUNT, LBL_SAVE, LBL_TEAM, LBL_SHIFT_DETAILS, LBL_EXPORT_TO_CSV, LBL_EXPORT_TO_PDF, LBL_TIME_CHANGE_REQUEST, LBL_TIME_CHANGE_REQUEST_CLIENT, LBL_ACCEPT, LBL_REJECT, LBL_CONFIRM_CANCEL_SHIFT_HEAD, LBL_CONFIRM_SHIFT_TIME_CHANGE_HEAD, LBL_CONFIRM_SHIFT_TIME_CHANGE_ACCEPT, LBL_CONFIRM_SHIFT_TIME_CHANGE_REJECT, LBL_ACCEPT_SHIFT_TIME_CHANGE_REQUEST, LBL_REJECT_SHIFT_TIME_CHANGE_REQUEST, LBL_PRIMARY_CONTACT, LBL_GENERATE_INVOICE, LBL_SELECT_All, LBL_SELECT_STAFF_DATA_FIELDS, LBL_DISCOUNT_AMOUNT, LBL_DISCOUNT_PERCENTAGE, LBL_SKILL, LBL_STATUS, LBL_AVAILABLE, LBL_UNAVAILABLE, LBL_CREW_UNAVAILABLE_PART, LBL_CREW_UNAVAILABLE_ALL, LBL_AVAILABILITY, LBL_DECLINE } from '../../configs/labelConfigs';

import PreviewQuote from './previewQuote';
import ShiftAdd from './shiftAdd';
import ShiftIndividualDetails from './shiftIndividualDetails';
import ShiftSkillsQuickEdit from './shiftSkillsQuickEdit';
import ClientContactAdd from '../client/tabContent/clientContactAdd';

import { availableAffVehicleAction, addAffVehicleAction, removeAffVehicleAction, listInvoiceAction, addRemoveVehicleAction, sendEventMessageAction, listEventMessagesAction, quoteEventLocationListAction, eventQuotePreviewAction, eventSummaryAction, eventClientDetailsAction, eventQuoteSummaryAction, quoteDownloadAction, shiftDeleteAction, eventListAction, sendShiftIdsForScheduleAction, shiftCancelAction, editQuoteDiscountAction, listEventShiftsAction, listEventShiftCrewAction, shifCrewListDownloadAction, shiftTimeChangeRequestAction, eventAffiliateDetailsAction, generateInvoiceAction, eventShiftsStaffListPDFDownloadAction } from '../../actions/eventActions';

import { showPreviewQuoteBtn, showRequestQuoteBtn, showAcceptRejectQuoteBtn, showAcceptRejectQuoteBtnAflt, showScheduleBtn, showSendQuoteBtn, showEventDeleteBtn, showEventCancelBtn, showShiftDeleteBtn, checkEventNotCancelled, checkShiftNotCancelled, shiftEditDisable, showShiftCancelBtn, showClientEventDeleteBtn, showShiftScheduleBtn, showAddShiftBtn, showShiftDuplicateBtn, showCompleteEventBtn, showDiscountBtn } from './eventStatusCheck';

import * as types from '../../actions';

import { showStaffVehicle, showSelectedVehicle } from '../commons/vehicleUtilities';
import { converDateToLocal, convertDecimalToHHMM } from '../../utils/commonUtilities';
import { checkPermissions } from '../../utils/permissions';
import { checkNumDotZero, decimalNumRegex } from '../../utils/validation';
// import Moment from 'react-moment';

const staffDataExportPDFFields = [
    { fieldName: 'name', label: 'Name', isChecked: true },
    { fieldName: 'photo', label: 'Photo', isChecked: true },
    { fieldName: 'phone', label: 'Phone', isChecked: true },
    { fieldName: 'email', label: 'Email', isChecked: true },
    { fieldName: 'address', label: 'Address', isChecked: true },
    { fieldName: 'position', label: 'Position', isChecked: true },
    { fieldName: 'skill', label: 'Skill', isChecked: true },
]

class QuoteDetails extends Component {
    scrollbars = React.createRef();
    constructor(props) {
        super()

        this.state = {
            mounted: false,
            messageText: '',
            messageError: false,
            activeRowId: 0,
            panelOpen: false,
            panelIndex: 0,
            activeShiftId: 0,
            activeShiftName: '',
            activeShiftDepartmentId: 0,
            panelOpenTeam: false,
            panelIndexTeam: 0,
            activeShiftIdTeam: 0,
            activeShiftNameTeam: '',
            messageCount: 0,
            botSentInvoice: false,
            selectedEventStatus: 0,
            activeShifLength: 0,
            eventDataForShift: {
                eventId: '',
                eventTitle: '',
                clientId: '',
                affiliateId: '',
                location: '',
                venueName: "",
                streetOne: "",
                streetTwo: "",
                city: "",
                state: "",
                country: "",
                postcode: "",
                startDate: "",
                endDate: "",
                googleLocation: ""
            },
            activeTab: TAB1,
            shiftId: '',
            shiftTitle: '',
            eventQuoteStatus: EVENT_STATUS,
            quoteStatus: QUOTE_STATUS,
            shiftStatus: SHIFT_STATUS,
            logClicked: 0,
            chk_all_checked: false,
            arrAllShiftIds: [],
            isDuplicate: false,
            loadPreviewQuoteEventIdCalled: 0,
            newClientContactAdded: 0,
            addContactClicked: 0,
            saveFormDataClicked: 0,
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            showEditDiscount: 0,
            discountError: '',
            discountType: '',
            discountValue: 0.00,
            discountPercentage: 0.00,
            discountValidError: '',
            eventShiftsList: [],
            eventShiftCrewList: [],
            accepted_count: 0,
            arrAccepted: [],
            exportShiftCrew: [],
            eventShiftStaffDetailsData: '',
            teamShiftId: 0,
            teamShiftAPICalled: 0,
            teamShiftCrewAPICalled: 0,
            exportShiftData: [],
            shiftTimeChangeType: '',
            shiftTimeChangeId: 0,
            selectedTeamShiftId: '',
            eventStaffDataExportPDFFields: staffDataExportPDFFields,
            selAllExportFields: true,
            shiftTimeChangeStaffAvailData: [],
            shiftTimeChangeStaffAvailStatus: '',
            goToScheduleAfterTimeChangeAccept: false,
            goToSchduleEventId: '',
            goToScheduleShiftData: {}
        }

        this.shiftAddEditRef = React.createRef();
        this.renderThumb = this.renderThumb.bind(this);
        this.contactModal = React.createRef();
        this.textInput = React.createRef();
        this.shiftTimeChangeModal = React.createRef();
        this.quickEditModal = React.createRef();
        this.modalDelete = React.createRef();
        this.modalInfo = React.createRef();
        this.modalShiftCancel = React.createRef();
        this.modalStaffPDFExport = React.createRef();
    }

    onAcceptShiftTimeChange = (e, actionType) => {
        let dataObj = {};
        let newRequest = actionType === 'REMOVECREW' ? true : actionType === 'NOTIFYCREW' ? false : '';
        if (this.state.shiftTimeChangeId > 0 && this.state.shiftTimeChangeType === 'Accept') {
            dataObj = { shift_id: this.state.shiftTimeChangeId, status: "accept", new_request: newRequest };
            this.shiftTimeChangeModal.current.handleModelClose();
            this.props.shiftTimeChangeRequestAction(dataObj);
        }
        else if (this.state.shiftTimeChangeId > 0 && this.state.shiftTimeChangeType === 'Reject') {
            this.shiftTimeChangeModal.current.handleOpenModal();
        }
    }

    onAcceptShiftTimeChangeConfirm = (e, actionType) => {
        let dataObj = {};
        let newRequest = true; // actionType === 'REMOVECREW' ? true : actionType === 'NOTIFYCREW' ? false : '';
        if (this.state.shiftTimeChangeId > 0 && this.state.shiftTimeChangeType === 'Accept') {
            this.setState({ goToScheduleAfterTimeChangeAccept: true }, () => {
                dataObj = { shift_id: this.state.shiftTimeChangeId, status: "accept", new_request: newRequest, shift_time_change_accepted: true };
                this.props.shiftTimeChangeRequestAction(dataObj);
            });
        }
        this.shiftTimeChangeModal.current.handleModelClose();
    }

    onChangeShiftTimeAction = () => {
        let dataObj = {};
        if (this.state.shiftTimeChangeId > 0 && this.state.shiftTimeChangeType === 'Reject') {
            dataObj = { shift_id: this.state.shiftTimeChangeId, status: "reject", new_request: '' };
            this.props.shiftTimeChangeRequestAction(dataObj);
        }
        this.shiftTimeChangeModal.current.handleModelClose();
    }

    onClickShiftTimeChange = (e, shiftId, status, actionType, eventId, shiftData) => {
        if (actionType === 'Accept' && (SHIFT_STATUS_ON_GOING === parseInt(status) || SHIFT_STATUS_CANCELLED === parseInt(status))) {
            // this.onAcceptShiftTimeChange(); 
            this.modalInfo.current.handleOpenModal();
        } else {
            this.setState({
                shiftTimeChangeId: shiftId, shiftTimeChangeType: actionType, shiftTimeChangeStaffAvailStatus: '', shiftTimeChangeStaffAvailData: [], goToScheduleAfterTimeChangeAccept: false, goToSchduleEventId: eventId, goToScheduleShiftData: shiftData
            }, () => {
                this.onAcceptShiftTimeChange();
            });

            // this.shiftTimeChangeModal.current.handleOpenModal();
        }

    }

    onShiftChange = (e) => {
        let shiftId = Number(e.target.value);
        if (!shiftId) {
            this.setState({ eventShiftCrewList: [], teamShiftId: 0, teamShiftCrewAPICalled: 0, accepted_count: 0, arrAccepted: [] });
        }
        else {
            this.setState({ teamShiftId: shiftId });
            this.props.listEventShiftCrewAction(shiftId);
        }
    }

    onShiftExpand = (shift_id) => {
        let shiftId = Number(shift_id);
        if (!shiftId) {
            this.setState({ eventShiftCrewList: [], teamShiftId: 0, teamShiftCrewAPICalled: 0, accepted_count: 0, arrAccepted: [] });
        }
        else {
            this.setState({ teamShiftId: shiftId });
            this.props.listEventShiftCrewAction(shiftId);
        }
    }

    saveDiscount = (e, quoteTotal) => {
        e.preventDefault();
        const value = this.state.discountValue;
        let discountError = '';
        let discountValidError = '';
        let valStr = value.trim();
        discountError = valStr.length <= 0 || decimalNumRegex.test(valStr) === false ? MSG_REQUIRED : "";
        if (valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
        else if (valStr && valStr !== '') {
            let t = valStr;
            valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            if (parseFloat(valStr) > parseFloat(quoteTotal)) discountValidError = MSG_DISCOUNT_VALID_ERROR;
        }
        if (discountError.length > 0 || discountValidError.length > 0) {
            this.setState({ discountError, discountValidError });
        }
        else {
            let dataObj = { eventId: this.props.eventIdSelected, discount_type: this.state.discountType, discount: this.state.discountType == DISCOUNT_TYPE_AMOUNT ? this.state.discountValue : this.state.discountPercentage }
            this.props.editQuoteDiscountAction(dataObj);
        }
    }

    onHandleChange = (e, quoteTotal, dType) => {
        e.preventDefault();
        const { value } = e.target;
        let discountError = '';
        let discountValidError = '';
        let valStr = value.trim();
        discountError = valStr.length <= 0 || decimalNumRegex.test(valStr) === false ? MSG_REQUIRED : "";
        if (valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }

        if (valStr === '') {
            if (dType === DISCOUNT_TYPE_PERCENTAGE) {
                this.setState({ discountValue: 0.00, discountPercentage: valStr });
            } else if (dType === DISCOUNT_TYPE_AMOUNT) {
                this.setState({ discountValue: valStr, discountPercentage: 0.00 });
            }
        }
        else if (valStr) {
            let t = valStr;
            valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            if (dType === DISCOUNT_TYPE_AMOUNT) {
                if (parseFloat(valStr) > parseFloat(quoteTotal)) {
                    discountValidError = MSG_DISCOUNT_VALID_ERROR;
                    this.setState({ discountValue: valStr, discountError, discountValidError });
                }
                else {
                    let dPerc = ((parseFloat(valStr) * 100) / parseFloat(quoteTotal)).toFixed(2);
                    this.setState({ discountValue: valStr, discountPercentage: dPerc, discountError, discountValidError });
                }

            }
            else if (dType === DISCOUNT_TYPE_PERCENTAGE) {
                if (parseFloat(valStr) > 100) {
                    discountValidError = MSG_DISCOUNT_VALID_ERROR;
                    this.setState({ discountError, discountValidError });
                }
                else {
                    let dValue = ((parseFloat(quoteTotal) * (parseFloat(valStr)) / 100)).toFixed(2);
                    this.setState({ discountValue: dValue, discountPercentage: valStr, discountError, discountValidError });
                }
            }
        }
    }

    onChangeDiscountType = (e, discType) => {
        // const { value } = e.target;
        this.setState({ discountType: discType });
        if (discType === DISCOUNT_TYPE_AMOUNT && document.getElementById("txtDiscountValue")) {
            //document.getElementById("txtDiscountValue").select();
            document.getElementById("txtDiscountValue").focus();
        }
        else if (discType === DISCOUNT_TYPE_PERCENTAGE && document.getElementById("txtDiscountPercentage")) {
            //document.getElementById("txtDiscountPercentage").select();
            document.getElementById("txtDiscountPercentage").focus();
        }
        //     document.getElementById("txtDiscountPercentage").disabled = true; 
        //     document.getElementById("txtDiscountPercentage").style.backgroundColor = '#DEDEDE';
        //     document.getElementById("txtDiscountValue").disabled = false; 
        //     document.getElementById("txtDiscountPercentage").style.backgroundColor = '#FFFFFF';
        //     document.getElementById("txtDiscountValue").select();
        //     document.getElementById("txtDiscountValue").disabled = true; 
        //     document.getElementById("txtDiscountValue").style.backgroundColor = '#DEDEDE';
        //     document.getElementById("txtDiscountPercentage").disabled = false; 
        //     document.getElementById("txtDiscountPercentage").style.backgroundColor = '#DEDEDE';
    }

    onMessageChange = (e) => {
        const value = e.target.value;
        this.setState({ messageText: value, messageError: false });
    }

    showEditDiscount = (showOption, discValue) => {
        if (showOption === 'show') {
            this.setState({ showEditDiscount: 1, discountValue: discValue });
            if (this.state.discountType.trim()) {
                this.onChangeDiscountType('', this.state.discountType);
            }
            // this.textInput.current.focus(); 
        }
        else if (showOption === 'hide') {
            this.setState({ showEditDiscount: 0, discountValue: discValue });
        }
    }

    openAddClientContact = (eventClientId) => {
        let addContactClicked = this.state.addContactClicked + 1;
        this.setState({ addContactClicked: addContactClicked }, () => {
            this.contactModal.current.handleOpenModal();
            setTimeout(() => {
                let contactModalPop = document.getElementById('contactModalPop');
                if (contactModalPop) {
                    contactModalPop.style.width = '650px';
                }
            }, 500);
        })
    }

    onSaveFormClientContactData = (e) => {
        let saveFormDataClicked = this.state.saveFormDataClicked + 1;
        this.setState({ saveFormDataClicked });
    }

    onModalClientContactFormReset = () => {

    }

    refreshParent = () => {
        let newClientContactAdded = this.state.newClientContactAdded + 1;
        this.setState({ newClientContactAdded }, () => {
            this.contactModal.current.handleModelClose();
        });
    }

    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    checkAll = (e, arrAllIds) => {
        if (this.state.chk_all_checked) {
            this.setState({ arrAllShiftIds: [], chk_all_checked: false });
        }
        else if (!this.state.chk_all_checked) {
            this.setState({ arrAllShiftIds: arrAllIds, chk_all_checked: true });
        }

    }
    checkAllChange = () => {

    }

    addRemoveCheck = (e, shiftId, arrAllIds) => {
        let arrIds = [];
        //let arrTmp = []; 
        if (this.state.arrAllShiftIds.indexOf(shiftId) !== -1) {
            this.state.arrAllShiftIds.forEach(item => {
                if (item && item !== shiftId) arrIds.push(item);
            })
        } else {
            arrIds = this.state.arrAllShiftIds;
            arrIds.push(shiftId);
        }
        let allchecked = false;
        if (arrIds.length === arrAllIds.length) allchecked = true;
        this.setState({ arrAllShiftIds: arrIds, chk_all_checked: allchecked });
    }

    reloadDetails = (shiftId) => {
        this.props.reloadQuoteDetails();
        if (this.props.eventIdSelected && this.props.eventIdSelected > 0) {
            this.props.eventQuoteSummaryAction(this.props.eventIdSelected);
            this.props.eventSummaryAction(this.props.eventIdSelected);
        }

        if (shiftId === this.state.activeShiftId) { // TO RELOAD THE CURRENT SHIFT DETAILS 
            this.setState({ activeShiftId: 0 }, () => {
                setTimeout(() => {
                    this.setState({ activeShiftId: shiftId });
                }, 750);
            })
        }
    }

    onSearchLocation = (query) => {
        let { eventDataForShift } = this.state;
        if (query.length >= SEARCH_TEXT_COUNT) {
            this.props.quoteEventLocationListAction({ pageSize: '', page: 0, column: '-id', search: query, affiliateId: eventDataForShift.affiliateId });
        }
    }

    onHideFilterBy = () => {
        document.getElementById("filterByMenu").classList.remove('active');
        let filterByMenu = document.getElementById('filterByMenu');
        let filterTab = document.getElementById('filterTab');
        let quoteTab = document.getElementById('detailTab');
        if (filterTab) {
            filterTab.style.display = 'block';
        }
        if (quoteTab) {
            quoteTab.style.display = 'none';
        }
        filterByMenu.style.width = '450px';
        filterByMenu.style.right = '-1000px';
        this.setState({ activeTab: TAB1 });
        if (this.props.needparentCallback && this.props.needparentCallback === 'yes') {
            this.props.onEventDetailsClose();
        }
    }

    renderThumb({ style, ...props }) {
        const thumbStyle = {
            backgroundColor: `#083461`,
            padding: 0,
            width: "4px",
            borderRadius: "3px",
        };
        return (
            <div
                style={{ ...style, ...thumbStyle }}
                {...props} />
        );
    }

    onShowActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-event-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-event-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        } else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        } else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-event-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-event-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-event-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-event-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    accordionChange = (eventKey, title) => {
        if (Number(eventKey) === this.state.panelIndex) {
            this.setState({ activeShiftId: eventKey, activeShiftName: title, panelOpen: !this.state.panelOpen, panelIndex: Number(eventKey) });
        } else {
            this.setState({ activeShiftId: eventKey, activeShiftName: title, panelOpen: true, panelIndex: Number(eventKey) });
        }
    }

    accordionChangeTeam = (eventKey, title) => {
        if (Number(eventKey) === this.state.panelIndexTeam) {
            this.setState({ activeShiftIdTeam: eventKey, activeShiftNameTeam: title, panelOpenTeam: !this.state.panelOpenTeam, panelIndexTeam: Number(eventKey) });
        } else {
            this.setState({ activeShiftIdTeam: eventKey, activeShiftNameTeam: title, panelOpenTeam: true, panelIndexTeam: Number(eventKey) });
            if (eventKey) this.onShiftExpand(eventKey);
        }
        this.props.availableAffVehicleAction(eventKey);
    }

    openEditQuoteModal = (shiftId, shiftName, shiftLength, deptId) => {
        this.setState({ activeShiftId: shiftId, activeShiftName: shiftName, activeShifLength: shiftLength, activeShiftDepartmentId: deptId }, () => {
            this.quickEditModal.current.handleOpenModal();
        })
    }

    closeEditQuoteModal = (shiftId, shiftName) => {
        this.quickEditModal.current.handleModelCloseOnly();
    }

    onModalFormReset = () => {
        this.setState({
            shiftId: '',
            shiftTitle: '',
        });
    }

    onSaveFormData = () => {

    }

    callPreviewQuote = (eventId) => {
        //here true is added to show stepper
        this.refs.previewQuote.handleOpenModal(true);
        this.props.eventQuotePreviewAction(eventId);
    }

    openPreviewQuote = () => {
        let { eventIdSelected } = this.props;
        this.refs.previewQuote.handleOpenModal();
        this.props.eventQuotePreviewAction(eventIdSelected);
    }

    editBtnClick = (shiftId) => {
        this.setState({ isDuplicate: false }, () => {
            this.shiftAddEditRef.current.openShiftModal(shiftId);
        });
    }

    duplicateShift = (shiftId) => {
        this.setState({ isDuplicate: true }, () => {
            this.shiftAddEditRef.current.openShiftModal(shiftId);
        });
    }

    deleteBtnClick = (shiftId, shiftTitle) => {
        this.setState({
            shiftId: shiftId,
            shiftTitle: shiftTitle
        });
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        let shiftId = this.state.shiftId;
        this.props.shiftDeleteAction(shiftId);
        this.modalDelete.current.handleModelClose();
    }

    cancelBtnClick = (shiftId) => {
        this.setState({
            shiftId: shiftId,
        });
        this.modalShiftCancel.current.handleOpenModal();
    }

    onCancelAction = () => {
        let shiftId = this.state.shiftId;
        this.props.shiftCancelAction(shiftId);
        this.modalShiftCancel.current.handleModelClose();
    }

    openAddShiftModal = () => {
        this.setState({ isDuplicate: false }, () => {
            this.shiftAddEditRef.current.openShiftModal();
        });
    }

    sendQuoteToClient = (eventId) => {
        this.props.openSendQuoteModal(eventId);
    }

    downloadQuote = (eventId) => {
        this.props.quoteDownloadAction(eventId);
    }

    editQuoteClick = (eventId, clientId) => {
        this.props.eventEditBtnClick(eventId, clientId);
    }

    deleteQuoteClick = (eventId, eventTitle) => {
        this.props.openEventDeleteModal(eventId, eventTitle);
    }

    cancelEventClick = (eventId) => {
        this.props.openEventCancelModal(eventId);
    }

    onEventCompletionClick = (eventId) => {
        this.props.onEventCompletion(eventId);
    }

    acceptQuoteBtnClickWithPO = (eventId, poNumber) => {
        this.props.openQuoteAcceptModalWithPO(eventId, poNumber);
    }

    acceptQuoteBtnClick = (eventId) => {
        this.props.openQuoteAcceptModal(eventId);
    }

    rejectQuoteBtnClick = (eventId) => {
        this.props.openRejectQuoteModal(eventId);
    }

    requestQuoteBtnClick = (eventId) => {
        this.props.openRequestQuoteModal(eventId);
        // setTimeout(()=> {
        //     this.refs.previewQuote.handleModelClose(); 
        // }, 1000);
    }

    scheduleShiftClick = (eventId) => {
        this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
    }

    // THIS FUNCTION CALLED FROM THIS PAGE ITSELF WHEN SHIFT TIME CHANGE REQUEST FROM CLIENT LOGIN IS ACCEPTED 
    // OR SCHEDULE SHIFT LINK IS CLICKED
    scheduleShift = (eventId, item) => {
        let { arrAllShiftIds } = this.state;
        let { eventSummary } = this.props;
        if (item) { // specific shift(s) selected from event summary schedule link
            let shiftItems = [];
            if (this.state.goToScheduleAfterTimeChangeAccept || (item.pending > 0 && item.required > 0)) {
                shiftItems = [{
                    start_datetime: item.start_datetime,
                    end_datetime: item.end_datetime,
                    skills: item.shift_skills,
                    shiftId: item.id,
                    chiefsRequired: item.chiefs_required,
                    chiefsPending: item.chiefs_pending,
                    isAllChecked: false,
                    status: item.status,
                    department: item.department !== null ? item.department.id : ''
                }];
            }
            this.props.sendShiftIdsForScheduleAction(shiftItems);
            this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
        } else { //shift(s) selected from checkbox
            let allShifts = eventSummary.shift_set;
            if (arrAllShiftIds.length > 0) {
                let filtteredshiftItems = allShifts.filter((val) => arrAllShiftIds.indexOf(val.id) !== -1 && val.pending > 0 && val.required > 0);
                let shiftItems = filtteredshiftItems.map(item => {
                    return {
                        start_datetime: item.start_datetime,
                        end_datetime: item.end_datetime,
                        skills: item.shift_skills,
                        shiftId: item.id,
                        chiefsRequired: item.chiefs_required,
                        chiefsPending: item.chiefs_pending,
                        isAllChecked: allShifts.length === filtteredshiftItems.length ? true : false,
                        status: item.status,
                        department: item.department !== null ? item.department.id : ''
                    };
                });
                this.props.sendShiftIdsForScheduleAction(shiftItems);
                this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
            } else { // no shift selected
                this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
            }
        }
    }

    // THIS FUNCTION CALLED FROM shiftAdd.js WHEN SHIFT TIME CHANGE IS ACCEPTED
    callScheduleShift = (eventId, shiftData, goToScheduleAfterTimeChangeAccept) => {
        if (eventId && shiftData && goToScheduleAfterTimeChangeAccept) {
            let shiftItems = [{
                start_datetime: shiftData.startDate,
                end_datetime: shiftData.endDate,
                skills: {},
                shiftId: shiftData.shiftId,
                chiefsRequired: false,
                chiefsPending: 0,
                isAllChecked: false,
                status: shiftData.shiftStatus,
                department: shiftData?.department !== null ? shiftData.department : '',
                resources: 1,
                pending: 1
            }];
            this.props.sendShiftIdsForScheduleAction(shiftItems);
            this.props.history.push(ROUTE_AFFILIATE_SCHEDULE_SHIFT + '/' + eventId);
        }
    }

    handleGenerateInvoice = (eventId) => {
        this.props.generateInvoiceAction(eventId);
    }


    callToaster(isEnabled, message, isSucces, autoHide = true) {
        this.props.setToasterState(isEnabled, message, isSucces, autoHide);
    }

    changeToEventList = () => {
        let urlVar = this.props.isClientPage ? ROUTE_CLIENT_EVENTS : ROUTE_AFFILIATE_EVENTS;
        if (this.props.eventIdSelected) this.props.history.push(urlVar + '/' + this.props.eventIdSelected);
        else this.props.history.push(urlVar);
    }

    reloadEventList = () => {
        this.props.eventListAction({ isEvent: this.props.isEvent, pageSize: this.props.perPageCount, page: this.props.activePage, column: this.props.sortOrder + this.props.sortField, search: this.props.searchQuote, applyFilter: this.props.applyFilter, filtersData: this.props.filtersData });
    }

    onTabChange = (e, tab) => {
        let { eventIdSelected } = this.props;
        let logClicked = 0;
        if (tab === TAB1) {
            this.props.eventSummaryAction(eventIdSelected);
            this.props.eventQuoteSummaryAction(eventIdSelected);
        } else if (tab === TAB2) {
            this.props.eventSummaryAction(eventIdSelected);
        } else if (tab === TAB3) {
            if (this.props.isClientPage) {
                this.props.eventAffiliateDetailsAction(eventIdSelected);
            }
            else {
                this.props.eventClientDetailsAction(eventIdSelected);
            }
        } else if (tab === TAB4) {
            logClicked = 1;
        } else if (tab === TAB5) {
            if (this.state.teamShiftAPICalled == 0) {
                this.props.listEventShiftsAction(eventIdSelected)
            }
        } else if (tab === TAB6) {
            this.props.listEventMessagesAction(eventIdSelected)
        } else if (tab === TAB7) {
            if (this.state.botSentInvoice || this.state.selectedEventStatus === EVENT_STATUS_INVOICED || this.props.activeTab === TAB7) {
                this.props.listInvoiceAction(eventIdSelected)
            } else {
                tab = TAB1;
            }

        }
        this.setState({ activeTab: tab, logClicked: logClicked });
        this.props.onTabChangeSet(tab);
    }

    formatShiftArray(array) {
        let exportShift = [];
        if (array.length > 0) {
            array.map(item => {
                let shiftObj = {};
                shiftObj['shift_name'] = item.shift_name;
                shiftObj['shift_date'] = item.shift_date;
                shiftObj['shift_start_time'] = item.shift_start_time;
                shiftObj['shift_end_time'] = item.shift_end_time;
                shiftObj['crew_names'] = item.crew_names;
                exportShift.push(shiftObj);
                return exportShift;
            });
        }
        return exportShift;
    }

    sendMessage = () => {
        if (this.state.messageText.trim() === '') {
            this.setState({ messageError: true });
        } else {
            this.props.sendEventMessageAction({ textMsg: this.state.messageText.trim(), eventId: this.props.eventIdSelected });
        }
    }

    keydownHandler = (e) => {
        if (e.keyCode === 13 && e.ctrlKey)
            this.sendMessage()
    }
    componentDidMount() {
        document.addEventListener('keydown', this.keydownHandler);
        this.setState({ mounted: true });
    }

    componentDidUpdate(prevProps) {
        const { affVehActivity, activity, messageActivity, sendEventActivity, downloadShiftCrewDataActivity, downloadShiftCrewDataStatus, downloadShiftCrewData, eventSummaryActivity, errorData, status, subactivity, quoteSummary, eventIdSelected, quoteFile, invoiceFile, eventId, previewQuoteActivity, loadPreviewQuoteEventId, email, userName, discActivity, eventShiftsList, eventShiftCrewList, invoiceGenerateActivity, eventShiftStaffPDFData, eventShiftStaffPDFDataStatus, eventShiftStaffPDFDataActivity } = this.props;
        this.state.mounted && this.scrollbars.current.scrollToBottom();
        if (affVehActivity && affVehActivity !== prevProps.affVehActivity) {
            let arrVehResp = affVehActivity.split('~~');
            if (arrVehResp[0] === types.AVAILABLE_AFF_VEHICLE_SUCCESS) {

            }
            else if (arrVehResp[0] === types.ADD_AFF_VEHICLE_SUCCESS) {
                this.props.availableAffVehicleAction(this.state.activeShiftIdTeam);
                this.onShiftExpand(this.state.activeShiftIdTeam)

            }
            else if (arrVehResp[0] === types.REMOVE_AFF_VEHICLE_SUCCESS) {
                this.props.availableAffVehicleAction(this.state.activeShiftIdTeam);
                this.onShiftExpand(this.state.activeShiftIdTeam)
            }
        }
        if (activity && activity !== prevProps.activity) {
            let arrActResp = activity.split('~~');
        }

        if (discActivity && discActivity !== prevProps.discActivity) {
            let arrDiscResp = discActivity.split('~~');
            if (arrDiscResp[0] === types.EVENT_DISCOUNT_EDIT_SUCCESS) {
                this.props.eventQuoteSummaryAction(this.props.eventIdSelected);
                this.callToaster(true, MSG_DISCOUNT_EDIT_SUCCESS, true);
                this.setState({ showEditDiscount: 0 });
            }
            else if (arrDiscResp[0] === types.EVENT_DISCOUNT_EDIT_ERROR) {
                this.callToaster(true, MSG_DISCOUNT_EDIT_ERROR, false);
            }
        }

        if (sendEventActivity && sendEventActivity !== prevProps.sendEventActivity) {
            let arrSendResp = sendEventActivity.split('~~');
            if (arrSendResp[0] === types.SEND_EVENT_MESSAGE_SUCCESS) {
                this.setState({ messageText: '' }, () => {
                    this.props.listEventMessagesAction(eventIdSelected)
                });

            }
        }

        if (messageActivity && messageActivity !== prevProps.messageActivity) {
            let arrSendResp = messageActivity.split('~~');
            if (arrSendResp[0] === types.EVENT_MESSAGES_LIST_SUCCESS) {
                this.setState({ messageCount: 0 });
            }
        }

        if (downloadShiftCrewDataActivity && (downloadShiftCrewDataStatus !== prevProps.downloadShiftCrewDataStatus || downloadShiftCrewDataActivity !== prevProps.downloadShiftCrewDataActivity)) {
            let arrDn = downloadShiftCrewDataActivity.split('~~');
            if (arrDn[0] === types.SHIFT_CREW_LIST_DOWNLOAD_SUCCESS) {

                this.setState({ exportShiftCrew: this.formatShiftArray(downloadShiftCrewData) }, () => {
                    setTimeout(() => {
                        let csvDownload = document.getElementById('CSVLinkDownloadShiftCrew');
                        csvDownload.click();
                    }, 500);
                });
            }
            else if (arrDn[0] === types.SHIFT_CREW_LIST_DOWNLOAD_ERROR) {
                this.setToasterState(true, MSG_CSV_DOWNLOAD_ERROR, false);
            }
        } // eventShiftStaffPDFData, eventShiftStaffPDFDataStatus, eventShiftStaffPDFDataActivity

        if (eventShiftStaffPDFDataActivity && (eventShiftStaffPDFDataStatus !== prevProps.eventShiftStaffPDFDataStatus || eventShiftStaffPDFDataActivity !== prevProps.eventShiftStaffPDFDataActivity)) {
            let arrDn22 = eventShiftStaffPDFDataActivity.split('~~');
            if (arrDn22[0] === types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS) {

                // Create a Blob from the response data
                const pdfBlob = new Blob([eventShiftStaffPDFData], { type: "application/pdf" });

                // Create a temporary URL for the Blob
                const pdfURL = window.URL.createObjectURL(pdfBlob);
                let pdfFileName = document.getElementById('staffDetPdfExportFileName').value;

                // Create a temporary <a> element to trigger the download
                const tempLink = document.createElement("a");
                tempLink.href = pdfURL;
                tempLink.setAttribute(
                    "download",
                    pdfFileName
                ); // Set the desired filename for the downloaded file

                // Append the <a> element to the body and click it to trigger the download
                document.body.appendChild(tempLink);
                tempLink.click();

                // Clean up the temporary elements and URL
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(pdfURL);

                this.modalStaffPDFExport.current.handleModelClose();

            }
            else if (arrDn22[0] === types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR) {
                this.setToasterState(true, MSG_PDF_DOWNLOAD_ERROR, false);
            }
        }



        if (this.state.loadPreviewQuoteEventIdCalled === 0 && loadPreviewQuoteEventId && Number(loadPreviewQuoteEventId) > 0) {
            this.setState({ loadPreviewQuoteEventIdCalled: 1 }, () => {
                this.callPreviewQuote(loadPreviewQuoteEventId);
            })
        }

        if (previewQuoteActivity !== prevProps.previewQuoteActivity && previewQuoteActivity === types.EVENT_QUOTE_PREVIEW_ERROR) {
            this.callToaster(true, MSG_SERVER_DATA_FETCH_ERROR, false);
            // previewQuoteStatus eventPreviewQuoteError 
        }

        if (invoiceGenerateActivity && invoiceGenerateActivity !== prevProps.invoiceGenerateActivity) {
            let arrTmpResp = invoiceGenerateActivity.split('~~');
            if (arrTmpResp[0] === types.GENERATE_INVOICE_SUCCESS) {
                this.callToaster(true, MSG_INVOICE_GENERATION_SUCCESS, true);

                if (this.props.eventIdSelected && this.props.eventIdSelected > 0) {
                    this.props.eventQuoteSummaryAction(this.props.eventIdSelected);
                    this.props.eventSummaryAction(this.props.eventIdSelected);
                }
                this.reloadEventList();
            }
            else if (arrTmpResp[0] === types.GENERATE_INVOICE_ERROR) {
                this.callToaster(true, MSG_INVOICE_GENERATION_ERROR, false);
            }
        }


        if (eventSummaryActivity && eventSummaryActivity !== prevProps.eventSummaryActivity) {
            let arrResponse = eventSummaryActivity.split('~~');
            if (arrResponse[0] === types.EVENT_SUMMARY_SUCCESS) {
                let dType = quoteSummary?.discount_type ? quoteSummary.discount_type : '';
                let dValue = quoteSummary?.discount_cost ? quoteSummary.discount_cost : 0.00;
                let dPerc = quoteSummary?.discount_percentage ? quoteSummary.discount_percentage : 0.00;
                this.setState({ discountType: dType, discountValue: dValue, discountPercentage: dPerc });
                // TO RELOAD THE SHIFT DETAILS VALUES LOADED IN shiftIndividualDetails 
                if (this.state.activeShiftId > 0) {
                    let activeShiftId = this.state.activeShiftId;
                    let activeShiftName = this.state.activeShiftName;
                    this.setState({ activeShiftId: 0, activeShiftName: '' }, () => {
                        this.setState({ activeShiftId: activeShiftId, activeShiftName: activeShiftName });
                    })
                }
            }
        }

        if (subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~');
            let actString = arrResp[0];
            if (actString === types.SHIFT_TIME_CHANGE_REQUEST_SUCCESS) {
                this.callToaster(true, MSG_SHIFT_TIME_CHANGE_ACCEPT_SUCCESS, true);
                if (this.state.goToScheduleAfterTimeChangeAccept && this.state.goToSchduleEventId) {
                    setTimeout(() => {
                        this.scheduleShift(this.state.goToSchduleEventId, this.state.goToScheduleShiftData);
                    }, 500);
                }
                else {
                    this.props.eventQuoteSummaryAction(this.props.eventIdSelected);
                    this.props.eventSummaryAction(this.props.eventIdSelected);
                    this.props.listEventShiftCrewAction(this.state.shiftTimeChangeId);
                    this.reloadEventList();
                }
            }
            else if (actString === types.SHIFT_TIME_CHANGE_REQUEST_ERROR) {
                let msgString = '';
                // SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE, SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE
                if (this.props.errorData && this.props.errorData?.availability && this.props.errorData?.staffs) {
                    this.setState({ shiftTimeChangeStaffAvailStatus: this.props.errorData.availability, shiftTimeChangeStaffAvailData: this.props.errorData.staffs, goToScheduleAfterTimeChangeAccept: false }, () => {
                        this.shiftTimeChangeModal.current.handleOpenModal();
                    });
                } else if (this.props.errorData.shift_ongoing_time_change_rejected !== undefined &&
                    this.props.errorData.shift_ongoing_time_change_rejected) {
                    this.modalInfo.current.handleOpenModal()
                } else {
                    if (this.state.shiftTimeChangeType === 'Accept') msgString = MSG_SHIFT_TIME_CHANGE_ACCEPT_FAILED;
                    else if (this.state.shiftTimeChangeType === 'Reject') msgString = MSG_SHIFT_TIME_CHANGE_REJECT_FAILED;
                    this.callToaster(true, msgString, false);
                }
            } else if (actString === types.ADD_REMOVE_VEHICLE_SUCCESS) {
                this.onShiftExpand(this.state.activeShiftIdTeam);
            }
            else if (actString === types.EVENT_SHIFT_CREW_LIST_SUCCESS) {
                let shiftCrewList = [];
                let arrAccepted = [];
                let accepted_count = 0;
                if (eventShiftCrewList) {
                    shiftCrewList = eventShiftCrewList;
                    arrAccepted = eventShiftCrewList.accepted ? eventShiftCrewList.accepted : [];
                    accepted_count = eventShiftCrewList.accepted_count ? eventShiftCrewList.accepted_count : 0;
                }
                this.setState({ eventShiftCrewList: shiftCrewList, arrAccepted, accepted_count, teamShiftCrewAPICalled: 1 }, () => {
                    if (eventShiftCrewList?.shift_id && eventShiftCrewList?.required_vehicles) {
                        this.modifyVehicleAllocInShiftList(eventShiftCrewList.shift_id, eventShiftCrewList.required_vehicles, eventShiftCrewList.assigned_vehicles);
                    }
                });
            }
            else if (actString === types.EVENT_SHIFT_CREW_LIST_ERROR) {
                this.setState({ teamShiftCrewAPICalled: 1 });
                this.callToaster(true, MSG_SERVER_DATA_FETCH_ERROR, false);
            } else if (actString === types.EVENT_SHIFTS_LIST_SUCCESS) {
                let shiftsList = [];
                if (Array.isArray(eventShiftsList)) shiftsList = eventShiftsList;
                this.setState({ eventShiftsList: shiftsList, teamShiftId: 0, arrAccepted: [], accepted_count: 0, teamShiftCrewAPICalled: 0 });
            }
            else if (actString === types.EVENT_SHIFTS_LIST_ERROR) {
                this.setState({ teamShiftAPICalled: 1, teamShiftId: 0, arrAccepted: [], accepted_count: 0, teamShiftCrewAPICalled: 0 });
                this.callToaster(true, MSG_SERVER_DATA_FETCH_ERROR, false);
            }
            else if (actString === types.EVENT_QUOTE_SUMMARY_SUCCESS) {
                if (quoteSummary.hasOwnProperty('id') && quoteSummary.id) {

                    this.setState({
                        eventDataForShift: {
                            eventId: quoteSummary.id,
                            eventTitle: quoteSummary.title,
                            clientId: quoteSummary.client_profile.id,
                            affiliateId: quoteSummary.affiliate_profile.id,
                            location: quoteSummary.location_detail.id,
                            venueName: quoteSummary.location_detail.location.venue === null ? '' : quoteSummary.location_detail.location.venue,
                            streetOne: quoteSummary.location_detail.location.street1,
                            streetTwo: quoteSummary.location_detail.location.street2,
                            city: quoteSummary.location_detail.location.city,
                            state: quoteSummary.location_detail.location.state,
                            country: quoteSummary.location_detail.location.country,
                            postcode: quoteSummary.location_detail.location.postcode,
                            googleLocation: quoteSummary.location_detail.location.lat_long,
                            startDate: quoteSummary.start_date,
                            endDate: quoteSummary.end_date,
                        }, messageCount: quoteSummary.message_count,
                        botSentInvoice: quoteSummary.bot_sent_invoice,
                        selectedEventStatus: quoteSummary.status
                    });
                    if (quoteSummary.bot_sent_invoice === false && this.state.activeTab === TAB7) {
                        this.onTabChange('', TAB1);
                    } else {
                        if (this.props.activeTab === TAB7)
                            this.onTabChange('', TAB7);
                    }
                }
                else {
                    //let stat = ''; 
                    let msg = MSG_SERVER_DATA_FETCH_ERROR + ' ' + MSG_EVENT_NOT_EXISTS;
                    this.callToaster(true, msg, false);
                }
            }
            else if (actString === types.QUOTE_SEND_CLIENT_SUCCESS) {
                this.callToaster(true, MSG_QUOTE_MAIL_SEND, true);
                this.refs.previewQuote.handleModelClose();
                this.props.eventQuoteSummaryAction(eventId);
                this.props.eventSummaryAction(eventId);
                this.reloadEventList();
            } else if (actString === types.QUOTE_SEND_CLIENT_ERROR) {
                if (status === 405 && errorData) {
                    // {"status":"failed","shift_department_not_filled":true,"shifts":[{"id":2308,"title":"Shift Two #2"}]}
                    if (errorData.shift_department_not_filled && Array.isArray(errorData.shifts) && errorData.shifts.length > 0) {
                        let shiftNames = '';
                        let sepVal = '';
                        errorData.shifts.forEach(item => {
                            shiftNames += sepVal + item.title;
                            sepVal = ', ';
                        });
                        this.callToaster(true, MSG_SHIFT_NO_DEPT_ERROR + ' - ' + shiftNames, false, false);
                    }
                    else {
                        let sendErrMsg = MSG_QUOTE_MAIL_SEND_ERROR;
                        if (this.props.errorData?.message) {
                            sendErrMsg = this.props.errorData.message === CLIENT_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED :
                                this.props.errorData.message === AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED :
                                    MSG_QUOTE_MAIL_SEND_ERROR;
                        }
                        this.callToaster(true, sendErrMsg, false);
                    }
                }
                else {
                    let sendErrMsg = MSG_QUOTE_MAIL_SEND_ERROR;
                    if (this.props.errorData?.message) {
                        sendErrMsg = this.props.errorData.message === CLIENT_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED :
                            this.props.errorData.message === AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED :
                                MSG_QUOTE_MAIL_SEND_ERROR;
                    }
                    this.callToaster(true, sendErrMsg, false);
                }
            } else if (actString === types.INVOICE_SEND_CLIENT_SUCCESS) {
                let message = MSG_INVOICE_MAIL_SEND + ', ' + userName + ' : ' + email;
                this.callToaster(true, message, true);
                this.refs.previewQuote.handleModelClose();
                this.props.eventQuoteSummaryAction(eventId);
                this.props.eventSummaryAction(eventId);
                this.reloadEventList();
            } else if (actString === types.INVOICE_SEND_CLIENT_ERROR) {
                let sendErrMsg = MSG_INVOICE_MAIL_SEND_ERROR;
                if (this.props.errorData?.message) {
                    sendErrMsg = this.props.errorData.message === CLIENT_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_CLIENT_EMAILS_MUTED :
                        this.props.errorData.message === AFFILIATE_ALL_CLIENTS_EMAILS_MUTED ? MSG_INVOICE_MAIL_SEND_ERR_ALL_CLIENTS_EMAIL_MUTED :
                            MSG_INVOICE_MAIL_SEND_ERROR;
                }
                this.callToaster(true, sendErrMsg, false);
            } else if (actString === types.QUOTE_ACCEPT_SUCCESS) {
                this.callToaster(true, MSG_QUOTE_ACCEPTED, true);
                if (this.props.isEvent === 1) {
                    this.refs.previewQuote.handleModelClose();
                    this.props.eventQuoteSummaryAction(eventId);
                    this.props.eventSummaryAction(eventId);
                    this.reloadEventList();
                }
                else {
                    this.changeToEventList();
                }
            } else if (actString === types.QUOTE_ACCEPT_ERROR) {
                if (status === 405 && errorData) {
                    // {"status":"failed","shift_department_not_filled":true,"shifts":[{"id":2308,"title":"Shift Two #2"}]}
                    if (errorData.shift_department_not_filled && Array.isArray(errorData.shifts) && errorData.shifts.length > 0) {
                        let shiftNames = '';
                        let sepVal = '';
                        errorData.shifts.forEach(item => {
                            shiftNames += sepVal + item.title;
                            sepVal = ', ';
                        });
                        this.callToaster(true, MSG_SHIFT_NO_DEPT_ERROR + ' - ' + shiftNames, false, false);
                    }
                    else {
                        this.callToaster(true, errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData), false);
                    }
                }
                else {
                    this.callToaster(true, errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData), false);
                }
            } else if (actString === types.QUOTE_REJECT_SUCCESS) {
                this.refs.previewQuote.handleModelClose();
                this.callToaster(true, MSG_QUOTE_REJECTED, true);
                this.props.eventQuoteSummaryAction(eventId);
                this.props.eventSummaryAction(eventId);
                this.reloadEventList();
            } else if (actString === types.QUOTE_REJECT_ERROR) {
                this.callToaster(true, errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData), false);
            } else if (actString === types.QUOTE_REQUEST_SUCCESS) {
                this.refs.previewQuote.handleModelClose();
                this.callToaster(true, MSG_QUOTE_REQUESTED, true);
                this.props.eventQuoteSummaryAction(eventId);
                this.props.eventSummaryAction(eventId);
                this.reloadEventList();
            } else if (actString === types.QUOTE_REQUEST_ERROR) {
                this.callToaster(true, errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData), false);
            } else if (actString === types.QUOTE_DOWNLOAD_SUCCESS) {
                if (quoteFile && quoteFile.length > 1) {
                    const link = document.createElement('a');
                    link.href = quoteFile;
                    link.download = 'download';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                else {
                    this.callToaster(true, MSG_QUOTE_DOWNLOAD_ERROR, false);
                }
            } else if (actString === types.QUOTE_DOWNLOAD_ERROR) {
                this.callToaster(true, MSG_QUOTE_DOWNLOAD_ERROR, false);
            } else if (actString === types.INVOICE_DOWNLOAD_SUCCESS) {
                if (invoiceFile && invoiceFile.length > 1) {
                    const link = document.createElement('a');
                    link.href = invoiceFile;
                    link.download = 'download';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                else {
                    this.callToaster(true, MSG_INVOICE_DOWNLOAD_ERROR, false);
                }
            } else if (actString === types.INVOICE_DOWNLOAD_ERROR) {
                this.callToaster(true, MSG_INVOICE_DOWNLOAD_ERROR, false);
            } else if (actString === types.EVENT_SHIFT_UPDATE_SUCCESS) {
                let msgStr = MSG_SHIFT_UPDATE;
                // resend_quote_for_client_approval:true SEND FROM SERVER SIDE WHEN CONFIRMED QUOTE CHANGED TO ESTIMATE/REESTIMATE ONLY, IF THIS IS TRUE NOTIFY THE USER   
                if (this.props.shiftUpdateData && this.props.shiftUpdateData.resend_quote_for_client_approval && this.props.shiftUpdateData.resend_quote_for_client_approval === true) {
                    msgStr = MSG_RESEND_QUOTE_FOR_CLIENT_APPROVAL;
                    this.callToaster(true, msgStr, true, false);
                }
                else {
                    this.callToaster(true, msgStr, true);
                }

                this.shiftAddEditRef.current.closeShiftModal();
                this.props.eventSummaryAction(eventIdSelected);
                this.props.eventQuoteSummaryAction(eventIdSelected);
                this.reloadEventList();
            } else if (actString === types.EVENT_SHIFT_UPDATE_ERROR) {
                if (errorData.availability && errorData.staffs) {
                    // ERROR IS DUE TO SHIFT TIME CHANGE WHILE SOME STAFF ACCEPTED THE SHIFT REQUEST 
                    // SHOW THE STAFF UNAVAILABILITY POPUP 
                }
                else {
                    let errMsg = MSG_SHIFT_UPDATE_ERROR;
                    if (errorData.error && errorData.error === 'past_time') errMsg = MSG_SHIFT_UPDATE_PAST_TIME_ERROR;
                    this.callToaster(true, errMsg, false); // JSON.stringify(errorData)
                }
            } else if (actString === types.SHIFT_DELETE_SUCCESS) {
                this.callToaster(true, MSG_SHIFT_DELETE, true);
                if (eventIdSelected) {
                    this.props.eventSummaryAction(eventIdSelected);
                }
                this.reloadEventList();
            } else if (actString === types.SHIFT_DELETE_ERROR) {
                if (status === 405) {
                    if (errorData.hasOwnProperty('message')) {
                        let errorMsg = errorData.message;
                        if (errorMsg === 'crews_assigned') {
                            this.callToaster(true, MSG_SHIFT_DELETE_ERROR, false);
                        } else {
                            this.callToaster(true, errorMsg, false);
                        }
                    }
                } else {
                    this.callToaster(true, JSON.stringify(errorData), false);
                }
            } else if (actString === types.SHIFT_CANCEL_SUCCESS) {
                this.callToaster(true, MSG_SHIFT_CANCELLED, true);
                if (eventIdSelected) {
                    this.props.eventSummaryAction(eventIdSelected);
                }
                this.reloadEventList();
            } else if (actString === types.SHIFT_CANCEL_ERROR) {
                // {status: 'failed', message: 'shift_cannot_be_cancelled', shift_status: 'Completed'}
                let cancelErrMsg = MSG_SHIFT_CANCEL_ERROR;
                if (errorData?.message && errorData.message == SHIFT_CANCEL_ERROR_CODE && errorData?.shift_status) {
                    // "Shift cancellation failed, The shift is already Completed."
                    cancelErrMsg = 'The shift is already ' + errorData.shift_status + ', ' + MSG_SHIFT_CANCEL_ERROR;
                }
                this.callToaster(true, cancelErrMsg, false);
            }
        }
    }

    onCSVDownload = (eventId) => {
        this.props.shifCrewListDownloadAction(eventId);
    }

    addRemoveVehicle = (action, scheduleShiftId, vehicleMasterId) => {
        this.props.addRemoveVehicleAction({ action: action, schedule_shift_id: scheduleShiftId, vehicle_master_id: vehicleMasterId })
    }
    onHandleVehChange = (e, schedule_id) => {
        let value = e.target.value;
        this.props.addAffVehicleAction({ "schedule_id": schedule_id, "vehicle_id": value });
    }
    removeAffVehChange = (e, schedule_id, vehicle_id) => {
        this.props.removeAffVehicleAction({ "schedule_id": schedule_id, "vehicle_id": vehicle_id });
    }

    onSelectAllChanged = () => {
        let selAll = !this.state.selAllExportFields;
        const updatedData = this.state.eventStaffDataExportPDFFields.map(field => ({
            ...field,
            isChecked: selAll,
        }));
        this.setState({ selAllExportFields: selAll, eventStaffDataExportPDFFields: updatedData });
    }

    onSelectItemChanged = (index) => {
        let currData = this.state.eventStaffDataExportPDFFields;
        const newDataToSet = currData;
        newDataToSet[index].isChecked = !currData[index].isChecked;
        this.setState({ eventStaffDataExportPDFFields: newDataToSet, selAllExportFields: newDataToSet.every((item) => item.isChecked) });
    }

    exportToPDFIconClick = () => {
        const updatedData = this.state.eventStaffDataExportPDFFields.map(field => ({
            ...field,
            isChecked: true,
        }));
        this.setState({ eventStaffDataExportPDFFields: updatedData, selAllExportFields: true }, () => {
            this.modalStaffPDFExport.current.handleOpenModal();
        });
    }

    onCancelStaffPDFExport = () => {
        const updatedData = this.state.eventStaffDataExportPDFFields.map(field => ({
            ...field,
            isChecked: true,
        }));
        this.setState({ eventStaffDataExportPDFFields: updatedData, selAllExportFields: true });
    }

    onEventShiftsStaffListPDFDownload = () => {
        if (this.props?.eventIdSelected) {
            const exportFields = this.state.eventStaffDataExportPDFFields
                .filter(field => field.isChecked)
                .reduce((acc, field) => {
                    acc[field.fieldName] = true;
                    return acc;
                }, {});

            exportFields.eventId = this.props.eventIdSelected;
            this.props.eventShiftsStaffListPDFDownloadAction(exportFields);
        }
    }

    modifyVehicleAllocInShiftList = (shiftId, reqVehicles, assignedVehicles) => {
        if (this.state.eventShiftsList && this.state.eventShiftsList.length) {
            let tmpEventShiftsList = this.state.eventShiftsList;
            let newEventShiftsList = tmpEventShiftsList.map(shift => {
                if (shift.shift_id === shiftId) {
                    return ({ ...shift, required_vehicles: reqVehicles, assigned_vehicles: assignedVehicles });
                } else {
                    return shift;
                }
            });
            this.setState({ eventShiftsList: newEventShiftsList });
        }
    }

    render() {
        const { panelOpen, panelIndex, eventQuoteStatus, shiftStatus, quoteStatus, showEditDiscount, discountError, discountType, discountValue, discountPercentage, discountValidError, eventShiftsList, eventShiftCrewList, arrAccepted, accepted_count, teamShiftId, teamShiftCrewAPICalled, teamShiftAPICalled, activeShiftIdTeam, activeShiftNameTeam, panelOpenTeam, panelIndexTeam } = this.state;
        const { affAvailVeh, listEventMessages, clientDetails, quoteSummary, eventSummary, eventPreviewQuote, profileCurrency, isClientPage, isEvent, affiliateDetails } = this.props;

        //let quoteVATPercentage = 0;
        //let quoteDiscountPercentage = 0; 
        //if(quoteSummary.hasOwnProperty('vat_percentage') && quoteSummary.vat_percentage.trim()) quoteVATPercentage = quoteSummary.vat_percentage;
        //if(quoteSummary.hasOwnProperty('discount_percentage') && quoteSummary.discount_percentage.trim()) quoteDiscountPercentage = quoteSummary.discount_percentage;

        let is_active = this.props.hasOwnProperty('is_active') ? this.props.is_active : true;

        let contactCompanyName = '';
        let contactCompanyEmail = '';
        let contactCompanyLocation = '';
        let contactCompanyWebsite = '';
        let contactCompanyPhone = '';

        let contactName = '';
        let contactPhoneNumber = '';
        let contactEmail = '';

        let eventStatus = 0;
        let quoteStatusCode = 0;
        let showPreviewQuote = true;
        let showRequestQuote = true;
        let showAcceptQuote = 0;
        let showRejectQuote = 0;
        let showSendQuote = true;
        let clientId = 0;
        let showDeleteEvent = true;
        let showCancelEvent = true;
        let eventNotCancelled = true;
        let showClientDeleteEvent = true;
        let showSchedule = true;
        let showAddShift = true;
        let showComplete = false;
        let invoiceData = [];

        if (clientDetails.hasOwnProperty('client_profile')) {
            contactCompanyName = clientDetails.client_profile.company_name;
            contactCompanyEmail = clientDetails.client_profile.company_email === null ? '' : clientDetails.client_profile.company_email;
            contactCompanyLocation = clientDetails.client_profile.location === null ? '' : clientDetails.client_profile.location.location;
            contactCompanyWebsite = clientDetails.client_profile.web_site;
            contactCompanyPhone = clientDetails.client_profile.phone_number === null ? '' : clientDetails.client_profile.phone_number;
        }

        if (clientDetails.hasOwnProperty('client_contact')) {
            contactName = clientDetails.client_contact.name;
            contactPhoneNumber = clientDetails.client_contact.phone_number;
            contactEmail = clientDetails.client_contact.user.email;
        }

        if (affiliateDetails.hasOwnProperty('affiliate_profile')) {
            contactCompanyName = affiliateDetails.affiliate_profile.company_name;
            contactCompanyEmail = affiliateDetails.affiliate_profile.company_email === null ? '' : affiliateDetails.affiliate_profile.company_email;
            contactCompanyLocation = affiliateDetails.affiliate_profile.location === null ? '' : affiliateDetails.affiliate_profile.location.location;
            contactCompanyWebsite = affiliateDetails.affiliate_profile.web_site;
            contactCompanyPhone = affiliateDetails.affiliate_profile.phone_number === null ? '' : affiliateDetails.affiliate_profile.phone_number;

            contactName = affiliateDetails.affiliate_profile.primary_contact_name;
            contactPhoneNumber = affiliateDetails.affiliate_profile.primary_contact_phone_number;
            contactEmail = affiliateDetails.affiliate_profile.primary_contact_email;

        }


        if (quoteSummary.hasOwnProperty('client_profile')) {
            clientId = quoteSummary.client_profile.id;
        }
        let shiftData = [];
        if (quoteSummary.hasOwnProperty('shift_set')) {
            let filteredShift = quoteSummary.shift_set.filter((data) => data != null);
            shiftData = filteredShift;
        }
        let shiftCount = shiftData.length;

        let eventId = '';
        if (quoteSummary.hasOwnProperty('id')) {
            eventId = quoteSummary.id;
        }

        let eventTitle = '';
        if (quoteSummary.hasOwnProperty('title')) {
            eventTitle = quoteSummary.title;
        }

        let eventLocation = '';
        //let eventVenue    = '';
        if (quoteSummary.hasOwnProperty('location_detail')) {
            eventLocation = quoteSummary.location_detail.location.location;
            //eventVenue = quoteSummary.location_detail.location.venue;
        }

        let timeZone = getUserTimeZone(this.props.location);
        let eventStartDate = '';
        let eventEndDate = '';
        if (quoteSummary.hasOwnProperty('start_date')) {
            // eventStartDate = quoteSummary.start_date;
            eventStartDate = converDateToLocal(quoteSummary.start_date, "+00:00", 'ddmmyyyy');
        }
        if (quoteSummary.hasOwnProperty('end_date')) {
            // eventEndDate = quoteSummary.end_date;
            eventEndDate = converDateToLocal(quoteSummary.end_date, "+00:00", 'ddmmyyyy');
        }

        let quoteNumber = '';
        let poNumber = '';
        let eventNumber = '';
        let signature = '';
        let isPOorSignAccepted = false;

        if (quoteSummary.hasOwnProperty('quote_number')) {
            quoteNumber = quoteSummary.quote_number;
        }
        if (quoteSummary.hasOwnProperty('po_number') && quoteSummary.po_number !== null) {
            poNumber = quoteSummary.po_number;
            if (poNumber.length > 0)
                isPOorSignAccepted = true;
        }
        if (quoteSummary.hasOwnProperty('event_number')) {
            eventNumber = LBL_EVENT_PREFIX + quoteSummary.event_number;
        }
        if (quoteSummary.hasOwnProperty('signature') && quoteSummary.signature !== null) {
            signature = quoteSummary.signature;
            if (signature.length > 0)
                isPOorSignAccepted = true;
        }

        let filteredQuoteStatus = [];
        if ((quoteSummary.quote_set !== undefined) && (quoteSummary.quote_set.length > 0)) {
            quoteStatusCode = quoteSummary.quote_set[0].quote_status;
            filteredQuoteStatus = quoteStatus.filter(x => Number(x.statusCode) === Number(quoteStatusCode));
        }

        eventStatus = quoteSummary.status;
        let quoteStatusValue = 1;
        if (filteredQuoteStatus.length > 0) {
            quoteStatusValue = filteredQuoteStatus[0].statusCode;
        }
        let createdBy = quoteSummary.created_by;

        let isAffiliateCanAcceptQuote = checkPermissions("acceptquote", "view"); // IF PERMISSION COMES SET THIS VARIABLE ACCORDING TO IT 
        let canAcceptQuote = isClientPage ? true : isAffiliateCanAcceptQuote;

        let displayDiscountBtn = 0;

        let filteredEventStatus = [];

        const isSuperAdmin = this.props.userGroup == LOGIN_SUPER_ADMIN_GROUP ? true : false;

        if (eventStatus !== undefined) {
            filteredEventStatus = eventQuoteStatus.filter(x => Number(x.statusCode) === Number(eventStatus));
            displayDiscountBtn = is_active === true && showDiscountBtn(isClientPage, eventStatus);
            showPreviewQuote = showPreviewQuoteBtn(isClientPage, eventStatus, quoteStatusValue, quoteSummary.quote_number, shiftCount);
            showRequestQuote = is_active === true && showRequestQuoteBtn(isClientPage, eventStatus, quoteStatusValue);
            showSendQuote = is_active === true && showSendQuoteBtn(isClientPage, quoteStatusValue, quoteSummary.quote_number, shiftCount, eventStatus);

            // FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
            if (!isClientPage && !isSuperAdmin) showAcceptQuote = showAcceptRejectQuoteBtnAflt(canAcceptQuote, eventStatus, quoteStatusValue);
            else showAcceptQuote = is_active === true && showAcceptRejectQuoteBtn(canAcceptQuote, eventStatus, quoteStatusValue);

            showRejectQuote = is_active === true && showAcceptRejectQuoteBtn(isClientPage, eventStatus, quoteStatusValue);

            showDeleteEvent = is_active === true && showEventDeleteBtn(isClientPage, eventStatus);
            showClientDeleteEvent = is_active === true && showClientEventDeleteBtn(isClientPage, eventStatus, createdBy);
            showCancelEvent = is_active === true && showEventCancelBtn(isClientPage, eventStatus);
            eventNotCancelled = checkEventNotCancelled(eventStatus);
            showSchedule = is_active === true && showScheduleBtn(isClientPage, shiftCount, eventStatus);
            showAddShift = is_active === true && showAddShiftBtn(eventStatus);
            showComplete = is_active === true && showCompleteEventBtn(isClientPage, eventStatus);
        }
        let subTotal = quoteSummary.total_cost;
        let discount = quoteSummary.discount_cost;
        let quoteDiscountType = quoteSummary.discount_type;
        let quoteDiscountPerc = quoteSummary.discount_percentage;
        let vatCost = quoteSummary.vat_cost;
        let quoteTotal = quoteSummary.total;

        let membersRequired = '';
        let membersAccepted = '';
        let membersRequested = '';
        let chiefCount = '';
        let note = '';
        let statusCount = [];
        let eventShiftData = [];
        let shiftIdsArr = [];
        if (eventSummary !== '') {
            membersRequired = eventSummary.required;
            membersAccepted = eventSummary.accepted;
            membersRequested = eventSummary.requested;
            chiefCount = eventSummary.chiefs_required;

            note = eventSummary.notes;
            statusCount = eventSummary.status_count;
            if (eventSummary.hasOwnProperty('shift_set') && eventSummary.shift_set) {
                let filteredShift = eventSummary.shift_set.filter((data) => data != null);
                eventShiftData = filteredShift;
                if (eventShiftData.length) {
                    shiftIdsArr = filteredShift.map(item => {
                        return (item.id);
                    })
                }
            }
        }

        let dataObj = { refType: LBL_EVENT, refId: eventId, logClicked: this.state.logClicked };
        let lblTo = LBL_TO.toLowerCase();
        let lblHrsShort = LBL_HOURS_SHORT.toLowerCase();
        let isAddEvent = is_active === true && !isSuperAdmin && checkPermissions("events", "modify");
        let isAddQuote = is_active === true && checkPermissions("quotes", "modify");
        let isQuoteSummary = checkPermissions("quotessummary", "view") && checkPermissions("quotes", "view");
        let isViewSchedule = checkPermissions("schedule", "view");

        let userGroupData = userGroupUrlCheck(window.location);
        let lblCrewChiefs = '';
        let lblCrew = 'staff';

        if (userGroupData !== undefined) {
            lblCrewChiefs = userGroupData.supervisor_name + '(s)';
            if (userGroupData.staff_name) {
                lblCrew = userGroupData.staff_name;
            }
        }
        let shiftCrewHeaders = [
            { label: "Shift Name", key: "shift_name" },
            { label: "Shift Date", key: "shift_date" },
            { label: "Start Time", key: "shift_start_time" },
            { label: "End Time", key: "shift_end_time" },
            { label: "Crew Name List", key: "crew_names" }
        ];
        let messageTo = LBL_CLIENT;
        if (isClientPage) {
            messageTo = LBL_AFFILIATE;
        }
        let newDate = new Date();

        let csvPdfDownloadFileName = '-' + LBL_EVENT.toLowerCase() + '-' + LBL_CREW.toLowerCase() + '-list';

        const showActionMenu = (showRequestQuote || showSendQuote || (shiftData.length > 0 && showAcceptQuote) || (Number(EVENT_STATUS_INVOICED) != Number(eventStatus) && !quoteSummary.bot_sent_invoice && is_active === true) || showRejectQuote ||
            showComplete || showDeleteEvent || showClientDeleteEvent || (showSchedule && !isSuperAdmin) || showCancelEvent);

        const showEventEdit = (Number(EVENT_STATUS_INVOICED) != Number(eventStatus) && !quoteSummary.bot_sent_invoice && is_active === true);

        return (
            <React.Fragment>
                <Toast toastDescription={this.state.toastMessagePop} toastFlag={this.state.toastFlagPop} toastSuccess={this.state.toastSuccessPop} closeToast={this.onCloseToastPop} />
                <div className="detail-head border-bottom pb-2 padding-top-7">
                    <h6>{eventTitle}
                        <button className="close-filter text-muted" onClick={this.onHideFilterBy}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </h6>
                    <div className="row">
                        <div className="col-md-3 p-0">
                            {filteredEventStatus.length > 0 &&
                                <p className={filteredEventStatus[0].colorClass + ' m-0 status-head'}>
                                    <small>
                                        <i className="fas fa-circle"></i> &nbsp;
                                        {isClientPage && filteredEventStatus[0].statusCode === QUOTE_SENT ? filteredEventStatus[0].clientStatusString : filteredEventStatus[0].statusString}
                                    </small>
                                </p>}
                        </div>
                        <div className="col-md-3 p-0"><p className="m-0"><small>{eventNumber}
                        </small></p></div>
                        <div className="col-md-3 p-0"><p className="m-0"><small>
                            {quoteNumber && <>{LBL_QUOTE} No: {quoteNumber}</>}
                        </small></p></div>
                        <div className="col-md-3 p-0"><p className="m-0"><small>
                            {poNumber && <>PO No: {poNumber}</>}
                        </small></p></div>
                    </div>
                </div>
                <Scrollbars style={{ "height": 'calc(100vh - 15vh)', "right": "-18px" }} autoHide renderThumbVertical={this.renderThumb} >
                    <div className="filter-content pt-3">
                        {eventNotCancelled && isAddEvent && !isSuperAdmin && showActionMenu &&
                            <div className="dropdown detail-drodown" id="dropdown-event-quote">
                                <button className="dropdown-toggle" type="button" id="dropdownMenuButton-quote" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={(e) => this.onShowActionButtons(e, 'quote')} >
                                    <input type="image" id={"img-action-" + 'quote'} src={require('../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, 'quote')} ></input>
                                </button>

                                <div className="dropdown-menu" id="dropdown-menu-event-quote"
                                    aria-labelledby="dropdown-menu-quote">
                                    {showRequestQuote &&
                                        <>
                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.requestQuoteBtnClick(eventId)}>{LBL_REQUEST_QUOTE}</Link>
                                        </>
                                    }

                                    {showSendQuote &&
                                        <>
                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.sendQuoteToClient(eventId)}>{LBL_SEND_QUOTE}</Link>
                                        </>
                                    }

                                    {shiftData.length > 0 && showAcceptQuote && isPOorSignAccepted == false &&
                                        <>
                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.acceptQuoteBtnClick(eventId)}>{LBL_ACCEPT_QUOTE}</Link>
                                        </>
                                    }

                                    {shiftData.length > 0 && showAcceptQuote && isPOorSignAccepted == true &&
                                        <>
                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.acceptQuoteBtnClickWithPO(eventId, poNumber)}>{LBL_ACCEPT_QUOTE}</Link>
                                        </>
                                    }

                                    {showEventEdit && is_active === true && <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editQuoteClick(eventId, clientId)}>{LBL_EDIT}</Link>}

                                    {showRejectQuote &&
                                        <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.rejectQuoteBtnClick(eventId)}>{LBL_REJECT_QUOTE}</Link>
                                    }

                                    {showComplete &&
                                        <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.onEventCompletionClick(eventId)}>{LBL_COMPLETE}</Link>
                                    }

                                    {showDeleteEvent &&
                                        <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.deleteQuoteClick(eventId, eventTitle)}>{LBL_DELETE}</Link>
                                    }

                                    {showClientDeleteEvent &&
                                        <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.deleteQuoteClick(eventId, eventTitle)}>{LBL_DELETE}</Link>
                                    }

                                    {showSchedule && !isSuperAdmin && <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.scheduleShiftClick(eventId)}>{LBL_SCHEDULE_SHIFT}</Link>}

                                    {showCancelEvent &&
                                        <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.cancelEventClick(eventId)}>{LBL_DECLINE}</Link>
                                    }

                                </div>
                            </div>
                        }
                        <p className="mb-0">
                            <i className="las la-map-marker-alt"></i><small>{[eventLocation].filter(Boolean).join(', ')}</small>
                        </p>

                        {/*<p className="pt-0"><small><i className="las la-calendar-alt"></i> <Moment format="DD/MM/YYYY ">{new Date(eventStartDate)}</Moment> &emsp; to &emsp; <i  className="las la-calendar-alt"></i> <Moment format="DD/MM/YYYY ">{new Date(eventEndDate)}</Moment>
                         </small></p> */}
                        <p className="pt-0"><small><i className="las la-calendar-alt"></i> {eventStartDate} &emsp; {lblTo} &emsp; <i className="las la-calendar-alt"></i> {eventEndDate} </small></p>



                        <Tab.Container id="quote-details-tab" activeKey={this.state.activeTab}>
                            <Nav variant="pills">
                                {isEvent === 1 &&
                                    <>
                                        <Nav.Item>
                                            <Nav.Link eventKey={TAB1} onClick={(e) => this.onTabChange(e, TAB1)}  >{LBL_EVENT_SUMMARY}</Nav.Link>
                                        </Nav.Item>
                                        {isQuoteSummary &&
                                            <Nav.Item>
                                                <Nav.Link eventKey={TAB2} onClick={(e) => this.onTabChange(e, TAB2)} >{LBL_QUOTE_SUMMARY}</Nav.Link>
                                            </Nav.Item>
                                        }

                                    </>
                                }

                                {isEvent === 0 &&
                                    <>
                                        <Nav.Item>
                                            <Nav.Link eventKey={TAB1} onClick={(e) => this.onTabChange(e, TAB1)} >{LBL_QUOTE_SUMMARY}</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={TAB2} onClick={(e) => this.onTabChange(e, TAB2)}  >{LBL_EVENT_SUMMARY}</Nav.Link>
                                        </Nav.Item>
                                    </>
                                }

                                <Nav.Item>
                                    <Nav.Link eventKey={TAB3} onClick={(e) => this.onTabChange(e, TAB3)} >{isClientPage ? LBL_AFFILIATE_DETAILS : LBL_CLIENT_DETAILS} </Nav.Link>
                                </Nav.Item>

                                <Nav.Item  >
                                    <Nav.Link eventKey={TAB5} onClick={(e) => this.onTabChange(e, TAB5)} >{LBL_TEAM} </Nav.Link>
                                </Nav.Item>

                                <Nav.Item>
                                    <Nav.Link eventKey={TAB6} onClick={(e) => this.onTabChange(e, TAB6)} ><span className="displayFlex">{LBL_MESSAGES}</span>{this.state.messageCount > 0 && <span className="alertSpan">{this.state.messageCount}</span>}</Nav.Link>
                                </Nav.Item>
                                {(this.state.botSentInvoice || Number(EVENT_STATUS_INVOICED) === Number(eventStatus)) &&
                                    <Nav.Item>
                                        <Nav.Link eventKey={TAB7} onClick={(e) => this.onTabChange(e, TAB7)} ><span className="displayFlex">{LBL_INVOICE}</span></Nav.Link>
                                    </Nav.Item>
                                }

                                {!isClientPage && <Nav.Item>
                                    <Nav.Link eventKey={TAB4} onClick={(e) => this.onTabChange(e, TAB4)} >{LBL_LOG}</Nav.Link>
                                </Nav.Item>}

                            </Nav>

                            {/* ********************************************************** */}
                            {/* *********************** QUOTE SUMMARY ******************** */}
                            {/* ********************************************************** */}
                            <Tab.Content>

                                <Tab.Pane eventKey={isEvent === 1 ? TAB2 : TAB1}>
                                    <div className="row">
                                        <div className="col-4 pl-2 pt-2"><small><b>
                                            {filteredQuoteStatus.length > 0 &&
                                                <>{LBL_QUOTE_STATUS}: <span className={filteredQuoteStatus[0].colorClass}><small className="status-fill">{isClientPage && filteredQuoteStatus[0].statusCode === QUOTE_SENT ? filteredQuoteStatus[0].clientStatusString : filteredQuoteStatus[0].statusString}</small></span></>
                                            }</b>
                                        </small>
                                        </div>
                                        <div className="col-8 text-right pr-0">
                                            {
                                                showPreviewQuote &&
                                                <>
                                                    <button className="btn btn-primary" onClick={this.openPreviewQuote}>{LBL_PREVIEW_QUOTE}</button>
                                                </>
                                            }
                                            {showSendQuote &&
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => this.sendQuoteToClient(eventId)}>{LBL_SEND_QUOTE}</button>
                                                </>
                                            }
                                            {shiftData.length > 0 && showAcceptQuote &&
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => isPOorSignAccepted ? this.acceptQuoteBtnClickWithPO(eventId, poNumber) : this.acceptQuoteBtnClick(eventId)}>{LBL_ACCEPT_QUOTE}</button>
                                                </>
                                            }
                                            {showCancelEvent &&
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => this.cancelEventClick(eventId)}>{LBL_DECLINE}</button>
                                                </>
                                            }

                                            {/* {shiftData.length > 0 && showAcceptQuote && isPOorSignAccepted == true &&
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => this.acceptQuoteBtnClickWithPO(eventId, poNumber)}>{LBL_ACCEPT_QUOTE}</button>
                                                </>
                                            } */}

                                            {showRequestQuote &&
                                                <>
                                                    <button className="btn btn-primary" onClick={(e) => this.requestQuoteBtnClick(eventId)}>{LBL_REQUEST_QUOTE}</button>
                                                </>
                                            }
                                            {showAddShift && isAddEvent &&
                                                <>
                                                    <button className="btn btn-primary" onClick={this.openAddShiftModal}><i className="las la-plus"></i>{LBL_ADD_SHIFT} </button>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="tab-container">
                                        {shiftData.length === 0 &&
                                            <span className="no-shift">{MSG_SHIFT_NOT_FOUND}</span>
                                        }
                                        <Accordion>
                                            {shiftData.map((item, index) => {
                                                let itemStartDatetime = converDateToLocal(item.start_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                                                let itemEndDatetime = converDateToLocal(item.end_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                                                //let showShiftEdit= showShiftEditBtn(item.status); 
                                                let disableShiftEdit = shiftEditDisable(item.status);
                                                let shiftLength = convertDecimalToHHMM(item.shift_length);
                                                return (
                                                    <>
                                                        <Card key={index} className={index === 0 ? 'first-card' : ''}>
                                                            <Card.Header>
                                                                <div className="row">
                                                                    <Accordion.Toggle as={Nav} variant="link" eventKey={item.id} className={panelOpen && panelIndex === item.id ? 'head-collp col-9' : 'head-collp collapsed col-9'} onClick={(e) => this.accordionChange(item.id, item.title)}>
                                                                        <p>
                                                                            <span className="change-count color-red text-bold ">{item.special_shift ? "! " : ""}</span>
                                                                            {item.title} (Dept:
                                                                            {item.department && <span> {item.department_name} </span>}
                                                                            {!item.department && <span className="dept_not_set"> Not Set </span>}
                                                                            )
                                                                        </p>
                                                                    </Accordion.Toggle>
                                                                    {eventNotCancelled && !disableShiftEdit && isAddEvent && item.edit && showEventEdit &&
                                                                        <div className="col-3 text-right p-r-0">
                                                                            <Link to="#" onClick={(e) => this.openEditQuoteModal(item.id, item.title, item.shift_length, item.department)}>{LBL_EDIT}</Link>
                                                                        </div>
                                                                    }
                                                                </div>

                                                                <div className="row padding-left-12">
                                                                    <div className="col-8">
                                                                        <p> <small><i className="las la-calendar-alt"></i> {itemStartDatetime} &emsp; {' ' + lblTo} &emsp; <i className="las la-calendar-alt"></i> {itemEndDatetime} &emsp; <i className="lar la-clock"></i> {shiftLength + ' ' + lblHrsShort} </small></p>
                                                                    </div>
                                                                    <div className="col-4 text-right" style={{ paddingRight: "0" }}>
                                                                        <p><small>{profileCurrency + ' ' + item.shift_total}</small></p>
                                                                    </div>
                                                                </div>
                                                                {(!item.same_as_event_location) &&
                                                                    <div className="row padding-left-12">
                                                                        <div className="col-12 padding-left-13">
                                                                            <p><i className="las la-map-marker-alt"></i>  <small> {item.shift_location.location.location}</small></p>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </Card.Header>
                                                            <Accordion.Collapse eventKey={item.id} >
                                                                <Card.Body>
                                                                    {(item.id === this.state.activeShiftId) && <ShiftIndividualDetails quoteShiftId={item.id} profileCurrency={profileCurrency} activeShiftId={this.state.activeShiftId}  ></ShiftIndividualDetails>}
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                    </>
                                                )
                                            })
                                            }
                                        </Accordion>
                                    </div>

                                    {shiftData.length > 0 &&
                                        <div className="table-footer">
                                            <div className="row">

                                                {/* <button className="btn btn-primary" onClick={(e) => this.saveDiscount(e,quoteTotal)}>{LBL_SAVE}</button>  <button className="btn btn-secondary input-num-100" onClick={(e) => this.showEditDiscount('hide',0)}>{LBL_CANCEL}</button> */}
                                                <div className="col-12 text-right">
                                                    <p className="mb-1">{LBL_SUB_TOTAL}&emsp;{profileCurrency} {subTotal}</p>
                                                </div>
                                            </div>

                                            {Number(discount) > 0 && <div className="row">
                                                <div className="col-12 text-right">
                                                    <p className="mb-1">
                                                        {LBL_DISCOUNT}
                                                        {quoteDiscountType && quoteDiscountType == DISCOUNT_TYPE_PERCENTAGE ? ' (' + quoteDiscountPerc + '%)' : ''}
                                                        &emsp; {' - ' + profileCurrency} {discount}</p>
                                                </div>
                                            </div>}

                                            <div className="row">
                                                <div className="col-12 text-right">
                                                    <p className="mb-1">{LBL_VAT} &emsp; {profileCurrency} {vatCost}</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-8 div-flex-left">
                                                    {isAddEvent && displayDiscountBtn === true && showEditDiscount === 0 && showEventEdit && <Link className="href-link-underline" to="#" onClick={(e) => this.showEditDiscount('show', discount)} >{LBL_EDIT_DISCOUNT}</Link>}
                                                    {!isClientPage && showEditDiscount > 0 && <>
                                                        <div className="div-flex width-100-percent">
                                                            <div className="padding-top-2"><label>{LBL_DISCOUNT}</label></div>
                                                            <div className="margin-left-10 div-flex ">
                                                                <div className="checkbox-wrapper">
                                                                    <div className="custom-radio">
                                                                        <input type="radio" id="radio1" name="radio" checked={discountType === DISCOUNT_TYPE_AMOUNT ? "checked" : ""} onChange={(e) => this.onChangeDiscountType(e, DISCOUNT_TYPE_AMOUNT)} />
                                                                        <label className="radio" htmlFor="radio1"></label>
                                                                        <label className="labeltext" htmlFor="radio1">{profileCurrency}</label>
                                                                        <input type="text" placeholder="Amount" id="txtDiscountValue" name="txtDiscountValue" onChange={(e) => this.onHandleChange(e, subTotal, DISCOUNT_TYPE_AMOUNT)} value={discountValue} maxLength={12}
                                                                            className={(parseFloat(discountValue) > parseFloat(subTotal) ? ' text-num-75 input-error ' : ' text-num-75 ') + (discountType === DISCOUNT_TYPE_PERCENTAGE ? ' disabledText ' : '')} readOnly={discountType === DISCOUNT_TYPE_PERCENTAGE} /> &nbsp;
                                                                    </div>
                                                                </div>
                                                                <div className='margin-left-10'> &nbsp;  </div>
                                                                <div className="checkbox-wrapper">
                                                                    <div className="custom-radio">
                                                                        <input type="radio" id="radio2" name="radio" checked={discountType === DISCOUNT_TYPE_PERCENTAGE ? "checked" : ""} onChange={(e) => this.onChangeDiscountType(e, DISCOUNT_TYPE_PERCENTAGE)} />
                                                                        <label className="radio" htmlFor="radio2"></label>
                                                                        <label className="labeltext" htmlFor="radio2">{'%'}</label>
                                                                        <input type="text" placeholder="Percentage" id="txtDiscountPercentage" name="txtDiscountPercentage" onChange={(e) => this.onHandleChange(e, subTotal, DISCOUNT_TYPE_PERCENTAGE)} value={discountPercentage} maxLength={6} className={(((parseFloat(discountValue) > parseFloat(subTotal)) || (parseInt(discountPercentage, 10) > 100)) ? ' text-num-75 input-error ' : ' text-num-75 ') + (discountType === DISCOUNT_TYPE_AMOUNT ? ' disabledText ' : '')} readOnly={discountType === DISCOUNT_TYPE_AMOUNT} /> &nbsp;
                                                                    </div>

                                                                </div> {/* discountValue,  discountPercentage */}
                                                            </div>

                                                            {/* <div className="select-input">  
                                                                <select onChange={(e) => this.onChangeDiscountType(e)} name="selDiscoutnType" value={''} >  
                                                                    <option value={DISCOUNT_TYPE_AMOUNT} >{LBL_DISCOUNT_AMOUNT}</option>
                                                                    <option value={DISCOUNT_TYPE_PERCENTAGE} >{LBL_DISCOUNT_PERCENTAGE}</option> 
                                                                </select>                           
                                                            </div> */}

                                                            <div>
                                                                {/* <Link className="href-link-underline" to="#" onClick={(e) => this.saveDiscount(e, subTotal)}>{LBL_SAVE}</Link>   */}
                                                                <button className="btn btn-primary mr-1 margin-left-10" onClick={(e) => this.saveDiscount(e, subTotal)}> {LBL_SAVE}</button>
                                                            </div>
                                                            <div>
                                                                {/* <Link className="href-link-underline" to="#" onClick={(e) => this.showEditDiscount('hide', 0)}>{LBL_CANCEL}</Link> */}
                                                                <button className="btn btn-secondary btn-cancel" onClick={(e) => this.showEditDiscount('hide', 0)}> {LBL_CANCEL}</button>
                                                            </div>
                                                        </div>
                                                    </>}
                                                </div>
                                                <div className="col-4 text-right">
                                                    <p className="mb-1">{LBL_GRAND_TOTAL} &emsp; {profileCurrency} {quoteTotal}</p>
                                                </div>
                                                {showEditDiscount > 0 && parseFloat(discountValue) > parseFloat(subTotal) && <div className="row col-8 div-flex-left text-red"><small>{MSG_DISCOUNT_VALID_ERROR}</small></div>}
                                            </div>
                                        </div>
                                    }
                                </Tab.Pane>

                                {/* ********************************************************** */}
                                {/* ********************** EVENT SUMMARY ********************* */}
                                {/* ********************************************************** */}
                                <Tab.Pane eventKey={isEvent === 0 ? TAB2 : TAB1}>
                                    {note &&
                                        <div className="row mt-12" >
                                            <div className="col-12">
                                                <p className="mb-1 h6"><small><strong>{LBL_NOTES}: </strong></small><span style={{ "fontSize": "12px" }}>{note}</span></p>
                                            </div>
                                        </div>
                                    }
                                    <div className="row mt-12">
                                        <div className="col-2">
                                            <p className="mb-0">{LBL_SHIFTS} ({eventShiftData.length})</p>
                                        </div>
                                        <div className="col-10 event-head d-flex justify-content-between">
                                            <ul>
                                                {statusCount &&
                                                    statusCount.map((item, index) => {
                                                        let filteredStatus = shiftStatus.filter(x => Number(x.statusCode) === Number(item.status));
                                                        let statusClass = '';
                                                        let statusStr = '';
                                                        let statusStrClient = '';
                                                        if (Array.isArray(filteredStatus) && filteredStatus[0] && filteredStatus[0].colorClass) {
                                                            statusClass = filteredStatus[0].colorClass;
                                                            statusStr = filteredStatus[0].statusString;
                                                            statusStrClient = filteredStatus[0].clientStatusString;
                                                        }

                                                        return (
                                                            <li key={index} className={item.count > 0 ? '' : 'hide'}><p>{isClientPage && item.status === Number(QUOTE_SENT) ? statusStrClient : statusStr} <span className={statusClass + ' circle'}>{item.count}</span></p></li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            {Number(EVENT_STATUS_COMPLETED) === Number(eventStatus) && <button className="btn btn-primary mr-1" onClick={(e) => this.handleGenerateInvoice(eventId)}> {LBL_GENERATE_INVOICE}</button>}
                                        </div>
                                    </div>
                                    <div className="event-container">
                                        <div className="row mt-0">
                                            <div className="col-7">
                                                {!isClientPage && <p className="mt-1 mb-0 h6 members-count"><small><strong>
                                                    <span>{LBL_MEMBERS_REQUIRED} : {membersRequired}</span>
                                                    <span>{LBL_ACCEPTED} : {membersAccepted}</span>
                                                    <span>{lblCrewChiefs} : {chiefCount}</span>
                                                    <span>{LBL_REQUESTED} : {membersRequested}</span>
                                                </strong> </small>
                                                </p>}
                                            </div>
                                            {/* <div className="col-4 h6">
                                                <p className="mb-1"><small><strong> {LBL_MEMBERS} assigned: {membersAssigned}</strong></small></p>
                                            </div> */}
                                            {eventNotCancelled &&
                                                <div className="col-5 text-right">
                                                    {showSchedule && isViewSchedule && !isSuperAdmin && <button className="btn btn-primary" onClick={(e) => this.scheduleShift(eventId)}><i className="lar la-clock"></i> {LBL_SCHEDULE_SHIFT}</button>}
                                                    {/* {showCancelEvent &&
                                                        <>
                                                            <button className="btn btn-primary" onClick={(e) => this.cancelEventClick(eventId)}>{LBL_DECLINE}</button>
                                                        </>
                                                    } */}
                                                    {showAddShift && isAddEvent && !isSuperAdmin &&
                                                        <button className="btn btn-primary" onClick={this.openAddShiftModal}><i className="las la-plus"></i>  {LBL_ADD_SHIFT}</button>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className="row table-responsive mb-3 margin-left-10">
                                            <table className="table border-0" id="eventdata-table">
                                                <thead className="bg-white">
                                                    <tr className="bt-table">
                                                        {showEventEdit && !isClientPage && !isSuperAdmin && !this.props.hideShiftCheckBoxes && <th className="sorting_disabled">
                                                            <div className="custom-checkbox"><input type="checkbox" id="shift-check-all" onClick={(e) => this.checkAll(e, shiftIdsArr)} checked={this.state.chk_all_checked} onChange={this.checkAllChange} /><label
                                                                className="checkbox" htmlFor="shift-check-all"></label></div>
                                                        </th>}
                                                        <th>{LBL_SLNUM}</th>
                                                        <th></th>
                                                        <th>{LBL_SHIFT_NAME}</th>
                                                        <th className="sorting_disabled">{LBL_SHIFT_TIME}</th>
                                                        {/* <th className="sorting_disabled">End Time</th> */}
                                                        <th className="sorting_disabled">{LBL_SHIFT_STATUS}</th>
                                                        <th className="sorting_disabled text-center">{LBL_CREW}</th>
                                                        {showSchedule && isViewSchedule && !isSuperAdmin &&
                                                            <th className="sorting_disabled text-center">{LBL_SCHEDULE_SHIFT}</th>
                                                        }
                                                        <th className="action sorting_disabled text-center">&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(eventShiftData.length === 0) &&
                                                        <tr>
                                                            <td colSpan="13" className="text-center">{MSG_SHIFT_NOT_FOUND}</td>
                                                        </tr>
                                                    }
                                                    {
                                                        eventShiftData.map((item, index) => {
                                                            filteredEventStatus = shiftStatus.filter(x => Number(x.statusCode) === Number(item.status));
                                                            let showShiftDelete = is_active === true && showShiftDeleteBtn(item.status);
                                                            let shiftNotCancelled = checkShiftNotCancelled(item.status);
                                                            let showShiftSchedule = is_active === true && showShiftScheduleBtn(item.status);

                                                            //let showShiftEdit= showShiftEditBtn(item.status);
                                                            //let disableShiftEdit = shiftEditDisable(item.status);
                                                            let showShiftCancel = is_active === true && showShiftCancelBtn(item.status);
                                                            let showShiftDuplicate = is_active === true && showShiftDuplicateBtn(item.status);


                                                            let previousStartDatetime = '';
                                                            let itemPreviousEndDatetime = '';
                                                            if (item.time_change_count > 0) {
                                                                previousStartDatetime = converDateToLocal(item.previous_start_datetime, timeZone.utc_offset, 'ddmmyyyyhhmm');
                                                                itemPreviousEndDatetime = converDateToLocal(item.previous_end_datetime, timeZone.utc_offset, 'hhmm');
                                                            }

                                                            let time_change_request = false;
                                                            let label_time_change_request = '';
                                                            let requested_start_time = '', requested_end_time = '', requested_start_date = '', requested_end_date = '', shiftReqLength = '';
                                                            if (item.time_change_request) {
                                                                time_change_request = true;
                                                                label_time_change_request = isClientPage ? LBL_TIME_CHANGE_REQUEST_CLIENT : LBL_TIME_CHANGE_REQUEST;
                                                                requested_start_time = converDateToLocal(item.requested_start_datetime, timeZone.utc_offset, 'hhmm');
                                                                requested_end_time = converDateToLocal(item.requested_end_datetime, timeZone.utc_offset, 'hhmm');
                                                                requested_start_date = converDateToLocal(item.requested_start_datetime, timeZone.utc_offset, 'ddmmyyyy');
                                                                requested_end_date = converDateToLocal(item.requested_end_datetime, timeZone.utc_offset, 'ddmmyyyy');
                                                                shiftReqLength = item.requested_shift_length && item.requested_shift_length.length > 0 ? convertDecimalToHHMM(item.requested_shift_length) : '';
                                                            }

                                                            let itemStartTime = converDateToLocal(item.start_datetime, timeZone.utc_offset, 'hhmm');
                                                            let itemEndTime = converDateToLocal(item.end_datetime, timeZone.utc_offset, 'hhmm');

                                                            let itemStartDate = converDateToLocal(item.start_datetime, timeZone.utc_offset, 'ddmmyyyy');
                                                            let itemEndDate = converDateToLocal(item.end_datetime, timeZone.utc_offset, 'ddmmyyyy');

                                                            let shiftLength = convertDecimalToHHMM(item.shift_length);

                                                            return (
                                                                <tr className="text-centerr" key={index}>
                                                                    {showEventEdit && !isClientPage && !isSuperAdmin && !this.props.hideShiftCheckBoxes && <td>
                                                                        {item.edit && <div className="custom-checkbox"><input type="checkbox" id={'event-check-' + index} onClick={(e) => this.addRemoveCheck(e, item.id, shiftIdsArr)} checked={this.state.arrAllShiftIds.indexOf(item.id) !== -1 ? true : false} onChange={this.checkAllChange} /><label
                                                                            className="checkbox" htmlFor={'event-check-' + index}></label></div>}
                                                                    </td>}
                                                                    <td>{index + 1}</td>
                                                                    <td className="veritcal-alignment-text-top max-width-15"><span className="change-count color-red text-bold ">{item.special_shift ? "! " : ""}</span></td>
                                                                    <td>
                                                                        {shiftNotCancelled && eventNotCancelled && showEventEdit && isAddEvent && item.edit && <Link onClick={(e) => this.editBtnClick(item.id)} to="#">{item.title} </Link>}
                                                                        {(!shiftNotCancelled || !showEventEdit || !isAddEvent || !item.edit) && <p className="mb-0">{item.title} </p>}
                                                                        <p className="mb-0">
                                                                            {item.shift_skills.length > 0 &&
                                                                                <OverlayTrigger
                                                                                    placement="right"
                                                                                    delay={{ show: 450, hide: 250 }}
                                                                                    overlay={<Tooltip id='skilltip-tooltip' style={{
                                                                                        opacity: 0.8,
                                                                                    }}>
                                                                                        {
                                                                                            item.shift_skills.map(e => e.skill.skill_name).join(",\r")
                                                                                        }
                                                                                    </Tooltip>}
                                                                                >
                                                                                    <small className="skill-tooltip" id="skilltip">
                                                                                        {
                                                                                            item.shift_skills.map(e => e.skill.skill_name.match(/\b(\w)/g).join("")).join(", ")
                                                                                        }

                                                                                    </small>
                                                                                </OverlayTrigger>

                                                                            }
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        {item.time_change_count > 0 &&
                                                                            <p className="text-danger mb-0"><small><s>{previousStartDatetime} - {itemPreviousEndDatetime}</s></small>{item.time_change_count > 1 && <span className="change-count">({item.time_change_count})</span>}</p>
                                                                        }
                                                                        {itemStartTime}-{itemEndTime} ({shiftLength + ' ' + LBL_HOURS_SHORT.toLowerCase()})

                                                                        <p className="mb-0"><small>{itemStartDate} - {itemEndDate}</small></p>

                                                                        {Number(EVENT_STATUS_COMPLETED) !== Number(eventStatus) && item.time_change_request === true &&
                                                                            <div className="mb-0">
                                                                                <small><div className="text-danger">{label_time_change_request}</div></small>
                                                                                <div>
                                                                                    {requested_start_time + ' - ' + requested_end_time}
                                                                                    {shiftReqLength !== '' && <span>{' (' + shiftReqLength + ' ' + LBL_HOURS_SHORT.toLowerCase() + ')'}</span>}
                                                                                </div>
                                                                                <div><small>{requested_start_date + ' - ' + requested_end_date}</small></div>
                                                                                {!isClientPage && !isSuperAdmin && <div>
                                                                                    <button className="btn btn-primary-small" onClick={(e) => this.onClickShiftTimeChange(e, item.id, item.status, 'Accept', eventId, item)} >{LBL_ACCEPT}</button> &nbsp;
                                                                                    <button className="btn btn-danger-small" onClick={(e) => this.onClickShiftTimeChange(e, item.id, item.status, 'Reject', eventId, item)} >{LBL_REJECT}</button>
                                                                                </div>}
                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td className={filteredEventStatus[0].colorClass}><small className="status-fill">{isClientPage && filteredEventStatus[0].statusCode === QUOTE_SENT ? filteredEventStatus[0].clientStatusString : filteredEventStatus[0].statusString}</small></td>
                                                                    <td className="text-center">{item.accepted}/{item.required}</td>
                                                                    {showSchedule && isViewSchedule && !isSuperAdmin &&
                                                                        <td className="text-center">
                                                                            {shiftNotCancelled && showShiftSchedule &&
                                                                                <Link to="#" onClick={(e) => this.scheduleShift(eventId, item)}><i className="lar la-clock" style={{ fontSize: "24px" }}></i></Link>
                                                                            }
                                                                        </td>
                                                                    }
                                                                    <td className="tex-center">

                                                                        {/* FOR SUPERADMIN ONLY - START  */}
                                                                        {shiftNotCancelled && isSuperAdmin &&
                                                                            <div className="dropdown" id={'dropdown-event-' + item.id}>
                                                                                <button className="dropdown-toggle" type="button"
                                                                                    id={'dropdownMenuButton-event-' + item.id} data-toggle="dropdown"
                                                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                                                >
                                                                                    <input type="image" id={"img-action-" + item.id} src={require('../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                                                </button>

                                                                                <div className="dropdown-menu" id={'dropdown-menu-event-' + item.id}
                                                                                    aria-labelledby={'dropdownMenuButton-event-' + item.id}>
                                                                                    <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.props.showShiftDetails(item.id)}>{LBL_SHIFT_DETAILS}</Link>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {/* FOR SUPERADMIN ONLY - END  */}


                                                                        {shiftNotCancelled && isAddEvent && item.edit &&
                                                                            <div className="dropdown" id={'dropdown-event-' + item.id}>
                                                                                <button className="dropdown-toggle" type="button"
                                                                                    id={'dropdownMenuButton-event-' + item.id} data-toggle="dropdown"
                                                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                                                >
                                                                                    <input type="image" id={"img-action-" + item.id} src={require('../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                                                </button>

                                                                                <div className="dropdown-menu" id={'dropdown-menu-event-' + item.id}
                                                                                    aria-labelledby={'dropdownMenuButton-event-' + item.id}>

                                                                                    {!isClientPage && <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.props.showShiftDetails(item.id)}>{LBL_SHIFT_DETAILS}</Link>}

                                                                                    {isAddEvent && item.edit && showEventEdit &&
                                                                                        <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                                                    }

                                                                                    {showShiftDuplicate && item.edit &&
                                                                                        isAddEvent &&
                                                                                        <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.duplicateShift(item.id)}>{LBL_DUPLICATE}</Link>
                                                                                    }

                                                                                    {showShiftDelete && isAddEvent && item.edit &&
                                                                                        <Link className="dropdown-item delete"
                                                                                            to="#" onMouseDown={(e) => this.deleteBtnClick(item.id, item.title)}>{LBL_DELETE}</Link>
                                                                                    }

                                                                                    {
                                                                                        showShiftCancel &&
                                                                                        !isClientPage &&
                                                                                        isAddEvent && item.edit &&
                                                                                        <Link className="dropdown-item delete"
                                                                                            to="#" onMouseDown={(e) => this.cancelBtnClick(item.id)}>{LBL_CANCEL}</Link>
                                                                                    }



                                                                                    {item.time_change_request === true && !isClientPage && !isSuperAdmin && item.edit &&
                                                                                        <>
                                                                                            <Link className="dropdown-item edit"
                                                                                                to="#" onMouseDown={(e) => this.onClickShiftTimeChange(e, item.id, item.status, 'Accept', eventId, item)}>{LBL_ACCEPT_SHIFT_TIME_CHANGE_REQUEST}</Link>
                                                                                            <Link className="dropdown-item delete"
                                                                                                to="#" onMouseDown={(e) => this.onClickShiftTimeChange(e, item.id, item.status, 'Reject', eventId, item)}>{LBL_REJECT_SHIFT_TIME_CHANGE_REQUEST}</Link>
                                                                                        </>
                                                                                    }

                                                                                </div>

                                                                            </div>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                </tbody>
                                            </table>
                                            <div className="clear-b-scroll-shift">&nbsp;</div>
                                            <div className="clear-b-scroll-shift">&nbsp;</div>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/* ********************************************************** */}
                                {/* ********************** CLIENT DETAILS ******************** */}
                                {/* ********************************************************** */}
                                <Tab.Pane eventKey={TAB3}>
                                    <div className="row tab-container client-tab-style mt-30">
                                        <div className="col-12">
                                            {contactCompanyName !== '' &&
                                                <p><small>{contactCompanyName}</small> </p>
                                            }
                                            {contactCompanyLocation !== '' &&
                                                <p><small>{contactCompanyLocation}</small></p>
                                            }
                                        </div>
                                        <div className="col-12 mt-3">
                                            {contactCompanyPhone !== '' &&
                                                <p><i className="las la-phone-alt"></i> <a href={'tel:' + contactCompanyPhone} title="">{contactCompanyPhone}</a></p>
                                            }
                                            {contactCompanyEmail !== '' &&
                                                <p><i className="las la-envelope"></i> <a href={'mailto:' + contactCompanyEmail} title="">{contactCompanyEmail}</a></p>
                                            }
                                            {contactCompanyWebsite && contactCompanyWebsite !== '' &&
                                                <p><i className="las la-globe"></i> <a href={'//' + contactCompanyWebsite} title="" target="_blank">{contactCompanyWebsite}</a></p>
                                            }
                                        </div>
                                        <div className="col-12 mt-5">
                                            <h6><small>{isClientPage ? LBL_PRIMARY_CONTACT : LBL_OFFICE_CONTACT}</small></h6>
                                            <p><small>{contactName}</small></p>
                                            <p><i className="las la-phone-alt"></i> <a href={'tel:' + contactPhoneNumber} title="">{contactPhoneNumber}</a></p>
                                            <p><i className="las la-envelope"></i> <a href={'mailto:' + contactEmail} title="">{contactEmail}</a></p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/* *********************************************************** */}
                                {/* ************************ TEAM DETAILS ********************* */}
                                {/* *********************************************************** */}
                                <Tab.Pane eventKey={TAB5}>
                                    {teamShiftAPICalled > 0 && (!eventShiftsList || eventShiftsList.length === 0) &&
                                        <div className="tab-container col-12"><span className="no-shift">{MSG_SHIFT_NOT_FOUND}</span></div>
                                    }
                                    {eventShiftsList && eventShiftsList.length > 0 &&
                                        <>
                                            <div className="text-right">
                                                <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={<Tooltip id="download-pdf-tooltip" style={{ opacity: 0.4, }}>
                                                            {LBL_EXPORT_TO_PDF}
                                                        </Tooltip>}
                                                    >
                                                        <Link to="#" onClick={e => this.exportToPDFIconClick()} className="btn btn-outline-primary filter-btn" ><i className="las la-file-pdf i-margin-top"></i></Link>
                                                    </OverlayTrigger>
                                                </div>
                                                <input type="hidden" id="staffDetPdfExportFileName" name="staffDetPdfExportFileName" value={eventTitle.replaceAll(/[^\p{L}\d\s]+/gu, '') + csvPdfDownloadFileName + '.pdf'} />

                                                <div className="btn-group btn-group-sm to-right export-icon filter-btn-wrapper">
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={<Tooltip id="download-tooltip" style={{ opacity: 0.4, }}>
                                                            {LBL_EXPORT_TO_CSV}
                                                        </Tooltip>}
                                                    >
                                                        <Link to="#" onClick={e => this.onCSVDownload(eventId)} className="btn btn-outline-primary filter-btn" ><i className="las la-file-download i-margin-top"></i></Link>
                                                    </OverlayTrigger>
                                                </div>
                                                <CSVLink id="CSVLinkDownloadShiftCrew" className="hidden" data={this.state.exportShiftCrew} headers={shiftCrewHeaders} filename={eventTitle.replaceAll(/[^\p{L}\d\s]+/gu, '') + csvPdfDownloadFileName + '.csv'}></CSVLink>
                                            </div>
                                        </>

                                    }
                                    {eventShiftsList && eventShiftsList.length > 0 && <Accordion>
                                        {eventShiftsList.map((item, index) => {
                                            // let itemStartDatetime = converDateToLocal(item.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
                                            // let itemEndDatetime = converDateToLocal(item.end_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
                                            // let shiftLength = convertDecimalToHHMM(item.shift_length); 

                                            let shift_id = item.shift_id;
                                            let shift_title = item.shift_title;
                                            item.start_datetime = item.status;
                                            let vehDetails = (item?.required_vehicles) ? (' (Vehicles: ' + item.required_vehicles + '/' + item.assigned_vehicles + ')') : '';
                                            let vehDetailsToolTip = (item?.required_vehicles) ? ('Vehicles: Required/Assigned') : '';

                                            return (
                                                <Card key={index} className={index === 0 ? 'first-card bgWhite  font-13' : 'bgWhite font-13'}>
                                                    <Card.Header className="bgWhite no-bottom-border">
                                                        <div className="row bgWhite">
                                                            <Accordion.Toggle as={Nav} variant="link" eventKey={shift_id} className={panelOpenTeam && panelIndexTeam === shift_id ? 'head-collp col-9 spanPointer ' : 'head-collp collapsed col-9 spanPointer '} onClick={(e) => this.accordionChangeTeam(shift_id, shift_title)}>
                                                                <span className="change-count color-red text-bold">{item.special_shift ? "! " : ""}</span>{shift_title}
                                                                <span title={vehDetailsToolTip}>{vehDetails}</span>
                                                            </Accordion.Toggle>
                                                        </div>
                                                    </Card.Header>
                                                    <Accordion.Collapse eventKey={shift_id} className="padding-left-32" >
                                                        {/* <Card.Body></Card.Body> */}
                                                        <div className={arrAccepted.length <= 0 ? 'margin-15 col-md-12 pl-0 pr-0 bg-white' : 'margin-15 schedule-crew-list-team col-md-12 pl-0 pr-0 bg-white'}>
                                                            {teamShiftCrewAPICalled > 0 && arrAccepted.length <= 0 &&
                                                                <div className="crew-list__noitem">{MSG_CREW_NOT_ACCEPTED}</div>
                                                            }

                                                            {arrAccepted.map((crew, index) => {
                                                                let crewVehicleAdded = false;
                                                                let vehicle_added = crew.vehicle_added;
                                                                let show_vehicle_for_client = true;
                                                                if (vehicle_added === false && this.props.isClientPage) {
                                                                    show_vehicle_for_client = false;
                                                                }
                                                                let imageClass = crew.chief_eligibility ? 'img-fluid img-prof-small img-crew-chief' : 'img-fluid img-prof-small';

                                                                let profileImgTag = <img className={imageClass} src={require('../../' + URL_IMG + 'crew-icon.jpg')} alt={crew.crew_name} title={crew.crew_name} />;

                                                                if ((crew.profile_picture) && crew.profile_picture.trim().length > 0) {
                                                                    profileImgTag = <img className={imageClass} src={crew.profile_picture} alt={crew.crew_name} title={crew.crew_name} />;
                                                                } else if (((!crew.profile_picture) || crew.profile_picture.trim().length === 0) && crew.avatar_name && crew.avatar_name.trim().length > 0) {
                                                                    profileImgTag = <div title={crew.crew_name} className={crew.chief_eligibility ? 'center-align img-fluid img-prof-small img-avatar img-crew-chief' : 'center-align img-fluid img-prof-small img-avatar'} style={{ background: crew.profile_color }}>{crew.avatar_name}</div>;
                                                                }

                                                                const chiefIcon = crew.is_crew_chief ? <span><img className='cheifimg-icon' src={require('../../' + URL_IMG + 'cheif.svg')}></img></span> : '';
                                                                ;
                                                                let crewRating = crew.crew_total_rating;
                                                                let department = crew.department.length > 0 ? crew.department.map(e => e.name).join(",\r") : '';

                                                                let nameLen = crew.is_crew_chief ? 9 : 12;
                                                                let crewFullName = crew.crew_name;
                                                                let crewShortName = crew.crew_name.length > nameLen ? crew.crew_name.substr(0, nameLen) + '...' : crew.crew_name;
                                                                let crewName = crewFullName !== crewShortName ? <OverlayTrigger placement="top"
                                                                    delay={{ show: 450, hide: 250 }} overlay={<Tooltip id='title-tooltip' style={{ opacity: 0.8, }}> {crewFullName} </Tooltip>} >
                                                                    <span className="title-tooltip" id="titletip"> {crewShortName} </span>
                                                                </OverlayTrigger> : crewFullName;
                                                                let phoneNumber = (crew.phone_number && crew.phone_number.length > 0) ? crew.phone_number : (crew.altername_number && crew.altername_number.length > 0) ? crew.altername_number : '';

                                                                let showVehicleSelection = this.state.eventShiftCrewList?.required_vehicles && this.state.eventShiftCrewList.required_vehicles > 0 && this.state.eventShiftCrewList.assigned_vehicles >= this.state.eventShiftCrewList.required_vehicles ? false : true;

                                                                return (
                                                                    <div className="s-crew-border team-border-event-det-team maxHeightNone" key={index}>
                                                                        <div className="">
                                                                            <div className="crew displayItemFlex teamCrew">
                                                                                <div className="crew__aside min-width-60">
                                                                                    <div className="crew__thumb">
                                                                                        {profileImgTag}
                                                                                    </div>

                                                                                    <span className="crew__badge font__size__12">{crew.omnu_points}</span>
                                                                                    <div className="crew__rating rating-display-only">
                                                                                        {CREW_MAX_RATING.map(ratingNum => {
                                                                                            if (Number(ratingNum) <= crewRating) {
                                                                                                return (
                                                                                                    <React.Fragment key={'rating' + ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating" + ratingNum} data-id={ratingNum} disabled={true} /><label htmlFor={"rating" + ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                                                                )
                                                                                            } else {
                                                                                                if (parseFloat(ratingNum) - 0.5 === parseFloat(crewRating)) {
                                                                                                    return (
                                                                                                        <React.Fragment key={'rating' + ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating" + ratingNum} disabled={true} /><label htmlFor={"rating" + ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                                                                    )
                                                                                                } else {
                                                                                                    return (
                                                                                                        <React.Fragment key={'rating' + ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating" + ratingNum} disabled={true} /><label htmlFor={"rating" + ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                        }
                                                                                    </div>
                                                                                    {crew.staff_vehicle && crew.staff_vehicle.length > 0 &&
                                                                                        <div className="d-flex gap-1 align-items-baseline
">
                                                                                            <span className="chief-icon background-black">
                                                                                                <img className="car-image" src={require('../../' + URL_IMG + 'car_filled.svg')} alt="Action" />
                                                                                            </span>
                                                                                            {crew.drive_to_shift_location && <div>
                                                                                                <i class="fas fa-solid fa-id-card mb-2"></i>
                                                                                            </div>}
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                <div className="crew__content">
                                                                                    <div className="crew__desc">

                                                                                        <div className="row paddingLeft15 mb-0 paddingBottomp0">
                                                                                            <div className="col8 text14Bold paddingBottomp0 ">{chiefIcon}<b>{crewName}</b> <p className="paddingTop0 paddingBottomp0"><small>{crew.pay_level_name}</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row paddingLeft15 paddingTop5 text11 text-muted">{department}</div>
                                                                                        <div className="row paddingLeft15 mb-0 paddingBottomp0 display-block">
                                                                                            {crew.skill.skill_name && crew.skill.skill_name.length > 0 &&
                                                                                                <React.Fragment >
                                                                                                    <p className="mb-0"><small><i className={'fas ' + crew.skill.skill_icon}></i> {crew.skill.skill_name}</small></p>
                                                                                                </React.Fragment>}
                                                                                        </div>
                                                                                        {phoneNumber.length > 0 && <div className="row paddingLeft15 paddingTop5 paddingBottom10 text11 text-muted">{'Ph: ' + phoneNumber}</div>}


                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {crew?.travel_cost_included && crew?.drive_to_shift_location ?
                                                                                <div>

                                                                                    {/* {!crew.added_affiliate_vehicle && show_vehicle_for_client && crew.staff_vehicle && crew.staff_vehicle.map((vehicle, index) => {
                                                                                        return (<div className="vehicleInfo">
                                                                                            {vehicle.map((info, index) => {
                                                                                                let disableVehicle = false;
                                                                                                if (crew.shift_status === SHIFT_STATUS_COMPLETED || crew.shift_status === SHIFT_STATUS_CANCELLED || isSuperAdmin) {
                                                                                                    disableVehicle = true;
                                                                                                }
                                                                                                if (info.vehicle_added === false && isAddEvent && !this.props.isClientPage && disableVehicle === false) {
                                                                                                    return (<div className="padding-top-10"><a className="textUl blueText spanPointer" onClick={(e) => this.addRemoveVehicle('add', crew.schedule_id, info.vehicle_master_id)}><span> {info.shift_status} {stringFormat(LBL_SELECT_VEHICLE, lblCrew)}</span></a>
                                                                                                    {showStaffVehicle(vehicle,timeZone)}
                                                                                                    </div>)
                                                                                                }
                                                                                            })}
                                                                                            {vehicle.map((info, index) => {
                                                                                                if (info.vehicle_added === true) {
                                                                                                    crewVehicleAdded = true;
                                                                                                }

                                                                                                let disableVehicle = false;
                                                                                                if (crew.shift_status === SHIFT_STATUS_COMPLETED || crew.shift_status === SHIFT_STATUS_CANCELLED || isSuperAdmin) {
                                                                                                    disableVehicle = true;
                                                                                                }

                                                                                                if (info.vehicle_added === 'completed' || info.vehicle_added === undefined) {
                                                                                                    return (<p className="paddingTop0 paddingBottomp0">{info.field_name ? info.field_name + ': ' : ''} <b>{info.field_type === 'string' ? info.text_value : converDateToLocal(info.date_value, timeZone.utc_offset, 'ddmmyyyy')}</b></p>)
                                                                                                } else if (info.vehicle_added === true && isAddEvent && !this.props.isClientPage && disableVehicle === false) {
                                                                                                    return (<div className="padding-top-10"><a className="textUl text-red spanPointer" onClick={(e) => this.addRemoveVehicle('remove', crew.schedule_id, info.vehicle_master_id)}><span> {info.shift_status} {stringFormat(LBL_REMOVE_CREW_VEHICLE, lblCrew)}</span></a></div>)
                                                                                                }

                                                                                            })}
                                                                                            {

                                                                                            }
                                                                                        </div>)
                                                                                    })
                                                                                    } */}

                                                                                    <div className="vehicleInfo">
                                                                                        {!crew.added_affiliate_vehicle && show_vehicle_for_client && crew.staff_vehicle && crew.staff_vehicle.map((vehicle, index) => {
                                                                                            let disableVehicle = false;
                                                                                            if (crew.shift_status === SHIFT_STATUS_COMPLETED || crew.shift_status === SHIFT_STATUS_CANCELLED || isSuperAdmin) {
                                                                                                disableVehicle = true;
                                                                                            }
                                                                                            if (vehicle.vehicle_added === true) {
                                                                                                crewVehicleAdded = true;
                                                                                            }

                                                                                            if (showVehicleSelection && vehicle.vehicle_added === false && isAddEvent && !this.props.isClientPage && disableVehicle === false) {
                                                                                                return (<div className="padding-top-10 padding-bottom-10"><a className="textUl blueText spanPointer" onClick={(e) => this.addRemoveVehicle('add', crew.schedule_id, vehicle.vehicle_master_id)}><span> {vehicle.shift_status} {stringFormat(LBL_SELECT_VEHICLE, lblCrew)}</span></a>
                                                                                                    <div style={{ marginTop: "5px", marginBottom: "8px" }}>{showStaffVehicle(vehicle, timeZone)}</div>
                                                                                                </div>)
                                                                                            }

                                                                                            if (crew.shift_status === SHIFT_STATUS_COMPLETED || crew.shift_status === SHIFT_STATUS_CANCELLED || isSuperAdmin) {
                                                                                                disableVehicle = true;
                                                                                            }

                                                                                            if (vehicle.vehicle_added === 'completed' || vehicle.vehicle_added === undefined) {
                                                                                                return (<p className="paddingTop0 paddingBottomp0">
                                                                                                    {vehicle.field_name ? vehicle.field_name + ': ' : ''} <b>
                                                                                                        {vehicle.field_type === 'string' ? vehicle.text_value : converDateToLocal(vehicle.date_value, timeZone.utc_offset, 'ddmmyyyy')}</b></p>)
                                                                                            } else if (vehicle.vehicle_added === true && isAddEvent && !this.props.isClientPage && disableVehicle === false) {
                                                                                                return (<div className="padding-top-10 padding-bottom-10">
                                                                                                    <div style={{ marginTop: "5px", marginBottom: "8px" }}>{showStaffVehicle(vehicle, timeZone)}</div>
                                                                                                    <a className="textUl text-red spanPointer" onClick={(e) => this.addRemoveVehicle('remove', crew.schedule_id, vehicle.vehicle_master_id)}><span> {vehicle.shift_status} {stringFormat(LBL_REMOVE_CREW_VEHICLE, lblCrew)}</span></a>
                                                                                                </div>)
                                                                                            }

                                                                                        })
                                                                                        }
                                                                                    </div>

                                                                                    {showVehicleSelection && crew.shift_status !== SHIFT_STATUS_COMPLETED && crew.shift_status !== SHIFT_STATUS_CANCELLED && isAddEvent && !this.props.isClientPage && crewVehicleAdded === false && !crew.added_affiliate_vehicle && affAvailVeh.length > 0 && crew.staff_vehicle && crew.staff_vehicle.length > 0 && !isSuperAdmin &&
                                                                                        <p className="or">{LBL_OR}</p>
                                                                                    }
                                                                                    {crew.added_affiliate_vehicle &&
                                                                                        <div className="vehicleInfo">
                                                                                            {showSelectedVehicle(crew.added_affiliate_vehicle.affiliatevehicledetails_set, timeZone)}
                                                                                            {/* {crew.added_affiliate_vehicle.affiliatevehicledetails_set.map((vehInfo, vehInfoIndex) => {
                                                                                                return (<p className="paddingTop0 paddingBottomp0">{vehInfo.field_name ? vehInfo.field_name + ': ' : ''} <b>{vehInfo.text_value ? vehInfo.text_value : vehInfo.date_value ? converDateToLocal(vehInfo.date_value, timeZone.utc_offset, 'ddmmyyyy') : ''}</b></p>)
                                                                                            })} */}
                                                                                        </div>
                                                                                    }
                                                                                    {crew.shift_status !== SHIFT_STATUS_COMPLETED && crew.shift_status !== SHIFT_STATUS_CANCELLED && isAddEvent && !this.props.isClientPage && crew.added_affiliate_vehicle && !isSuperAdmin &&
                                                                                        <div className="aff-veh-padd padding-top-10"><a className="textUl text-red spanPointer" onClick={(e) => this.removeAffVehChange(e, crew.schedule_id, crew.added_affiliate_vehicle.id)}><span> {LBL_REMOVE_AFF_VEHICLE}</span></a></div>
                                                                                    }

                                                                                    {showVehicleSelection && crew.shift_status !== SHIFT_STATUS_COMPLETED && crew.shift_status !== SHIFT_STATUS_CANCELLED && isAddEvent && !this.props.isClientPage && crewVehicleAdded === false && !crew.added_affiliate_vehicle && affAvailVeh.length > 0 && !isSuperAdmin &&
                                                                                        <><div className="vehicle-select">
                                                                                            <label>{LBL_AFF_VEH_DETAILS}</label>
                                                                                            <div className="form-group select-input">
                                                                                                <select name={"affVehicleSelect_" + index} onChange={(e) => this.onHandleVehChange(e, crew.schedule_id)} value={''}>
                                                                                                    <option value=''>{LBL_NOT_SELECTED}</option>
                                                                                                    {affAvailVeh.map((vehItem, vehIndex) => {
                                                                                                        let text_value = ''
                                                                                                        if (vehItem.affiliatevehicledetails_set.length === 1) {
                                                                                                            if (vehItem.affiliatevehicledetails_set[0].text_value) {
                                                                                                                text_value = vehItem.affiliatevehicledetails_set[0].text_value;
                                                                                                            } else if (vehItem.affiliatevehicledetails_set[0].date_value) {
                                                                                                                text_value = converDateToLocal(vehItem.affiliatevehicledetails_set[0].date_value, timeZone.utc_offset, 'ddmmyyyy');
                                                                                                            }
                                                                                                        } else if (vehItem.affiliatevehicledetails_set.length > 1) {
                                                                                                            if (vehItem.affiliatevehicledetails_set[0].text_value) {
                                                                                                                text_value = vehItem.affiliatevehicledetails_set[0].text_value + ' - ';
                                                                                                            } else if (vehItem.affiliatevehicledetails_set[0].date_value) {
                                                                                                                text_value = converDateToLocal(vehItem.affiliatevehicledetails_set[0].date_value, timeZone.utc_offset, 'ddmmyyyy') + ' - ';
                                                                                                            }
                                                                                                            if (vehItem.affiliatevehicledetails_set[1].text_value) {
                                                                                                                text_value = text_value + vehItem.affiliatevehicledetails_set[1].text_value;
                                                                                                            } else if (vehItem.affiliatevehicledetails_set[1].date_value) {
                                                                                                                text_value = text_value + converDateToLocal(vehItem.affiliatevehicledetails_set[1].date_value, timeZone.utc_offset, 'ddmmyyyy');
                                                                                                            }
                                                                                                        }
                                                                                                        return (
                                                                                                            <option value={vehItem.id}>{text_value}</option>
                                                                                                        )
                                                                                                    })

                                                                                                    }

                                                                                                </select>
                                                                                            </div>
                                                                                        </div>
                                                                                        </>
                                                                                    }


                                                                                </div>
                                                                                :
                                                                                <></>
                                                                            }

                                                                        </div>

                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>


                                                    </Accordion.Collapse>
                                                </Card>
                                            )
                                        })
                                        }
                                    </Accordion>
                                    }
                                </Tab.Pane>


                                {/* ********************************************************** */}
                                {/* ************************ LOG DETAILS ********************* */}
                                {/* ********************************************************** */}
                                <Tab.Pane eventKey={TAB4}>
                                    <LogComponent location={this.props.location} dataObj={dataObj} />
                                </Tab.Pane>

                                {/* ********************************************************** */}
                                {/* ************************ Messages ********************* */}
                                {/* ********************************************************** */}
                                <Tab.Pane eventKey={TAB6}>
                                    <div className="tab-container col-12">
                                        <Scrollbars ref={this.scrollbars} style={{ "height": 'calc(60vh - 15vh)' }} autoHide renderThumbVertical={this.renderThumb} >
                                            {listEventMessages.length > 0 && listEventMessages[0].communication.map((message, index) => {

                                                return (
                                                    <div key={index} className="row">
                                                        <div className="col-12">
                                                            <span className="text-bold labelText">{message.message_by.user_name}</span>
                                                            <span className="text-bold nav-pills labelText">{":"}</span>
                                                            <span className="nav-pills textWrap labelText">{message.message}</span>
                                                            <div className="col-12 text-right">
                                                                <small>{message.message_by.time_string}</small>
                                                            </div>

                                                        </div>
                                                        {/*<div className="col-1">
                                                            <span className="text-bold text-right">{":"}</span>
                                                        </div>
                                                        <div className="col-8">
                                                            <span className="no-shift textWrap">{message.message}</span>
                                                        </div>*/}
                                                    </div>
                                                )

                                            })}
                                            {listEventMessages.length === 0 &&
                                                <div className="text-center">
                                                    <span className="no-shift">{LBL_NO_MESSAGES}</span>
                                                </div>
                                            }
                                        </Scrollbars>
                                    </div>
                                    {isAddEvent && !isSuperAdmin && <div className="row marginTop15">
                                        <div className="col-md-12 paddingRightLeft0">
                                            <div className="form-group">
                                                <label>{stringFormat(LBL_MESSAGE_TO, messageTo)}</label>
                                                <textarea className={this.state.messageError ? "input-error form-control" : "form-control"} name="message" maxLength={256} onChange={(e) => this.onMessageChange(e)} value={this.state.messageText || ''}></textarea>
                                            </div>
                                        </div>
                                    </div>}
                                    {isAddEvent && !isSuperAdmin && <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group text-right">
                                                <button className="btn btn-primary" onClick={this.sendMessage}>{LBL_SEND}</button>
                                            </div>
                                        </div>
                                    </div>}
                                </Tab.Pane>
                                {/* ********************************************************** */}
                                {/* ************************ INVOICE ********************* */}
                                {/* ********************************************************** */}
                                {(this.state.botSentInvoice || Number(EVENT_STATUS_INVOICED) === Number(eventStatus)) && <Tab.Pane eventKey={TAB7}>
                                    <InvoiceComponent location={this.props.location} event_id={this.props.eventIdSelected} isClientPage={isClientPage} isAddEvent={isAddEvent} />
                                </Tab.Pane>}
                            </Tab.Content>

                        </Tab.Container>
                    </div>
                </Scrollbars>

                <ModalWindow ref={this.quickEditModal} header={LBL_EDIT_QUOTE + " - " + this.state.activeShiftName} saveFormData={(e) => this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="updateQuote" noFooterButtons='yes' >
                    <ShiftSkillsQuickEdit quoteShiftId={this.state.activeShiftId} quoteShiftName={this.state.activeShiftName} profileCurrency={profileCurrency} closeEditQuoteModal={this.closeEditQuoteModal} shiftLengthHrs={this.state.activeShifLength} reloadQuoteDetails={this.reloadDetails} reloadDetails={this.reloadDetails} clientId={this.props.clientId} affiliateProfileId={this.props.affiliateProfileId} userGroup={this.props.userGroup} reloadEventList={this.reloadEventList} {...this.state} callToaster={this.props.setToasterState} />
                </ModalWindow>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {LBL_CONFIRM_DELETE_SHIFT + ' ' + this.state.shiftTitle + "' ?"}
                </ModalWindow>

                <ModalWindow ref={this.modalInfo} header={LBL_INFO} type="Info" >
                    {MSG_ACCEP_GOING_CANCELLED}
                </ModalWindow>

                <ModalWindow ref={this.modalShiftCancel} header={LBL_CONFIRM_CANCEL_SHIFT_HEAD} type="confirm" deleteConfirmedItem={this.onCancelAction} resetModalForm={this.onModalFormReset} >
                    {LBL_CONFIRM_CANCEL_SHIFT}
                </ModalWindow>

                {/* THIS MODAL USED TO SHOW ACCEPTED STAFF UNAVAILABILITY ON FROM CLIENT LOGIN SHIFT TIME CHANGE REQUEST */}
                <ModalWindow
                    modalId="shiftTimeChangeModalPop"
                    ref={this.shiftTimeChangeModal}
                    header={this.state.shiftTimeChangeType === 'Accept' ? (this.state.shiftTimeChangeStaffAvailStatus == SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE ? LBL_CREW_UNAVAILABLE_PART : this.state.shiftTimeChangeStaffAvailStatus == SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE ? LBL_CREW_UNAVAILABLE_ALL : '') : LBL_CONFIRM_SHIFT_TIME_CHANGE_HEAD + ' - ' + this.state.shiftTimeChangeType}
                    type={this.state.shiftTimeChangeType === 'Accept' ? 'AcceptTimeChange' : this.state.shiftTimeChangeType === 'Reject' ? 'confirm' : ''}
                    deleteConfirmedItem={this.onChangeShiftTimeAction}
                    acceptShiftTimeChange={this.onAcceptShiftTimeChangeConfirm}
                    resetModalForm={this.onModalFormReset}
                    shiftTimeChangeStaffAvailStatus={this.state.shiftTimeChangeStaffAvailStatus}
                >
                    <div className="padding-bottom-15">
                        <div><h2>{'Event Detials'}</h2></div>
                        {/* {this.state.shiftTimeChangeType === 'Accept' ? LBL_CONFIRM_SHIFT_TIME_CHANGE_ACCEPT : this.state.shiftTimeChangeType === 'Reject' ? LBL_CONFIRM_SHIFT_TIME_CHANGE_REJECT : ''} */}

                        {this.state.shiftTimeChangeType === 'Reject' ? LBL_CONFIRM_SHIFT_TIME_CHANGE_REJECT : ''}

                        {this.state.shiftTimeChangeType === 'Accept' && this.state.shiftTimeChangeStaffAvailData.length ? <table className="table border-0" id="eventdata-table">
                            <thead className="bg-white">
                                <tr className="bt-table">
                                    <th>{LBL_SLNUM}</th>
                                    <th>{LBL_CREW}</th>
                                    <th>{LBL_SKILL}</th>
                                    <th>{LBL_STATUS}</th>
                                    <th>{LBL_AVAILABILITY}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.shiftTimeChangeStaffAvailData.map((item, index) => {
                                    let scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode) === Number(item.schedule_status));
                                    return (
                                        <tr className="text-centerr" key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.crew_name}</td>
                                            <td>{item.skill_name}</td>
                                            <td>{scheduleShiftStatus[0]?.statusString}</td>
                                            <td className={item.available ? '' : ' color-red '}>{item.available ? LBL_AVAILABLE : LBL_UNAVAILABLE}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table> : <></>}
                    </div>
                </ModalWindow>

                <PreviewQuote ref="previewQuote" resetModalForm={this.onModalFormReset} eventPreviewQuote={eventPreviewQuote} sendQuoteToClient={this.sendQuoteToClient} acceptQuote={this.acceptQuoteBtnClick} acceptQuoteWithPO={this.acceptQuoteBtnClickWithPO} rejectQuote={this.rejectQuoteBtnClick} downloadQuote={this.downloadQuote} quoteDownloadFileName={this.props.quoteFile} invoiceDownloadFileName={this.props.invoiceFile} isClientPage={this.props.isClientPage} profileCurrency={profileCurrency} eventStatus={eventStatus} requestQuoteBtnClick={this.requestQuoteBtnClick} is_active={is_active} >
                </PreviewQuote>

                <ShiftAdd ref={this.shiftAddEditRef} onsearchLocation={this.onSearchLocation} isClientPage={this.props.isClientPage} reloadEventList={this.reloadEventList} {...this.state} callPreviewQuote={this.callPreviewQuote} openAddClientContact={this.openAddClientContact} scheduleShift={this.callScheduleShift} eventDetails={'eventDetails'} />

                <ModalWindow modalId="contactModalPop" ref={this.contactModal} header={LBL_ADD_NEW_CLIENT_CONTACT} saveFormData={(e) => this.onSaveFormClientContactData(e)} resetModalForm={this.onModalClientContactFormReset} type="save" >
                    <ClientContactAdd saveFormDataClicked={this.state.saveFormDataClicked} newClientContactAdded={this.state.newClientContactAdded} refreshParent={this.refreshParent} clientId={this.state.eventDataForShift.clientId} setToasterStatePop={this.setToasterStatePop} addContactClicked={this.state.addContactClicked} ></ClientContactAdd>
                </ModalWindow>

                <ModalWindow ref={this.modalStaffPDFExport} header={LBL_SELECT_STAFF_DATA_FIELDS} type="eventStaffDetPDFExport" resetModalForm={this.onCancelStaffPDFExport} isSaveBtnEnable={this.state.eventStaffDataExportPDFFields.some(field => field.isChecked)} exportEventStaffDataPDF={e => this.onEventShiftsStaffListPDFDownload()} >
                    <div className="dashboard dashboardLog">
                        <div className="">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="marginBottom10">
                                        <ListGroup id={'listG'} className={""}>
                                            <ListGroup.Item key={'selectAll'} >
                                                <Row >
                                                    <Col className="custom-checkbox-mul padding-5" md={12}>
                                                        <label className="label-checkbox row" htmlFor={'selectAll'} >
                                                            <input
                                                                type="checkbox"
                                                                id={'selectAll'}
                                                                checked={this.state.selAllExportFields}
                                                                onChange={(e) => this.onSelectAllChanged()}
                                                            />
                                                            <span className="label-check">{LBL_SELECT_All}</span>
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                            <ListGroup.Item key={'allItems'} >
                                                <Row >
                                                    {this.state.eventStaffDataExportPDFFields.map((item, index) => {
                                                        return (
                                                            <Col key={'field' + index} className="custom-checkbox-mul padding-5" >
                                                                <label className="label-checkbox row" htmlFor={item.value} >
                                                                    <input
                                                                        type="checkbox"
                                                                        id={item.value}
                                                                        checked={item.isChecked}
                                                                        onChange={(e) => this.onSelectItemChanged(index)}
                                                                    />
                                                                    <span className="label-check">{item.label}</span>
                                                                </label>
                                                            </Col>
                                                        )
                                                    })}
                                                </Row>
                                            </ListGroup.Item>

                                            {/* {this.state.eventStaffDataExportPDFFields.map((item, index) => {
                                            return(    
                                                <ListGroup.Item key={'field'+index} >
                                                        <Col className="custom-checkbox-mul" >                                
                                                            <label className="label-checkbox row" htmlFor={item.value} >
                                                                <input
                                                                    type="checkbox"
                                                                    id={item.value}
                                                                    checked={item.isChecked}
                                                                    onChange={(e) => this.onSelectItemChanged(index)}
                                                                />
                                                                <span className="label-check">{item.label}</span>
                                                            </label>
                                                        </Col>
                                                </ListGroup.Item>     
                                            )
                                            })} */}
                                        </ListGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalWindow>

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        status: state.event.status,
        subactivity: state.event.subactivity,
        discActivity: state.event.discActivity,
        activity: state.event.activity,
        invoiceActivity: state.event.invoiceActivity,
        invoiceGenerateActivity: state.event.invoiceGenerateActivity,
        errorData: state.event.errorData,
        clientDetails: state.event.clientDetails,
        quoteSummary: state.event.quoteSummary,
        eventSummary: state.event.eventSummary,
        eventPreviewQuote: state.event.eventPreviewQuote,
        previewQuoteStatus: state.event.previewQuoteStatus,
        previewQuoteActivity: state.event.previewQuoteActivity,
        eventPreviewQuoteError: state.event.eventPreviewQuoteError,
        actionLogs: state.event.actionLogs,
        quoteFile: state.event.quoteFile,
        invoiceFile: state.event.invoiceFile,
        eventId: state.event.eventId,
        email: state.event.email,
        userName: state.event.userName,
        listEventMessages: state.event.listEventMessages,
        eventSummaryActivity: state.event.eventSummaryActivity,
        eventShiftsList: state.event.eventShiftsList,
        eventShiftCrewList: state.event.eventShiftCrewList,
        shiftUpdateData: state.event.shiftUpdateData,
        downloadShiftCrewData: state.event.downloadShiftCrewData,
        downloadShiftCrewDataStatus: state.event.downloadShiftCrewDataStatus,
        downloadShiftCrewDataActivity: state.event.downloadShiftCrewDataActivity,
        eventShiftStaffPDFData: state.event.eventShiftStaffPDFData,
        eventShiftStaffPDFDataStatus: state.event.eventShiftStaffPDFDataStatus,
        eventShiftStaffPDFDataActivity: state.event.eventShiftStaffPDFDataActivity,
        sendEventActivity: state.event.sendEventActivity,
        messageActivity: state.event.messageActivity,
        affAvailVeh: state.event.affAvailVeh,
        affAvailVehData: state.event.affAvailVehData,
        affVehActivity: state.event.affVehActivity,
        affiliateDetails: state.event.affiliateDetails,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        quoteEventLocationListAction: quoteEventLocationListAction,
        eventQuotePreviewAction: eventQuotePreviewAction,
        eventQuoteSummaryAction: eventQuoteSummaryAction,
        eventSummaryAction: eventSummaryAction,
        eventClientDetailsAction: eventClientDetailsAction,
        generateInvoiceAction: generateInvoiceAction,
        quoteDownloadAction: quoteDownloadAction,
        shiftDeleteAction: shiftDeleteAction,
        eventListAction: eventListAction,
        sendShiftIdsForScheduleAction: sendShiftIdsForScheduleAction,
        shiftCancelAction: shiftCancelAction,
        editQuoteDiscountAction: editQuoteDiscountAction,
        listEventShiftsAction: listEventShiftsAction,
        listEventShiftCrewAction: listEventShiftCrewAction,
        shifCrewListDownloadAction: shifCrewListDownloadAction,
        eventShiftsStaffListPDFDownloadAction: eventShiftsStaffListPDFDownloadAction,
        listEventMessagesAction: listEventMessagesAction,
        sendEventMessageAction: sendEventMessageAction,
        shiftTimeChangeRequestAction: shiftTimeChangeRequestAction,
        addRemoveVehicleAction: addRemoveVehicleAction,
        listInvoiceAction: listInvoiceAction,
        availableAffVehicleAction: availableAffVehicleAction,
        addAffVehicleAction: addAffVehicleAction,
        removeAffVehicleAction: removeAffVehicleAction,
        eventAffiliateDetailsAction: eventAffiliateDetailsAction,

    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QuoteDetails));